// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-09T16:37:33.712Z
// Property: Parc at Murfreesboro (ID: 5757210235764736)
// Collections: 32 amenities, 7 floorplans (live), 34 photos, 84 POIs, 4 reviews, 5 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5757210235764736",
  "property_external_id": "4810270",
  "property_zillow_url": "https://www.zillow.com/apartments/murfreesboro-tn/parc-at-murfreesboro/BXhSzC/",
  "property_apartments_url": "https://www.apartments.com/parc-at-murfreesboro-murfreesboro-tn/01t10r1",
  "property_google_business_url": "https://www.google.com/maps/place/Parc+at+Murfreesboro/@35.9035423,-86.3845354,15z/data=!4m2!3m1!1s0x0:0xd0f128208d961f3?sa=X&ved=2ahUKEwi6wuLI8fPtAhUGo1kKHcceDuUQ_BIwEnoECCUQBQ",
  "property_linkedin_url": null,
  "property_hubspot_id": "2437207418",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "parc-at-murfreesboro",
  "property_name": "Parc at Murfreesboro",
  "property_website_url": "https://www.parcatmurfreesboro.com",
  "property_domain": "https://www.parcatmurfreesboro.com/",
  "property_address": "3237 Memorial Blvd",
  "property_full_address": "3237 Memorial Blvd, Murfreesboro, TN 37129",
  "property_address_1": "3237 Memorial Blvd",
  "property_address_2": null,
  "property_address_city": "Murfreesboro",
  "property_address_state": "TN",
  "property_address_zip_full": "37129-5247",
  "property_address_zip": "37129",
  "property_address_country": "US",
  "property_address_county": "Rutherford County",
  "property_neighborhood_address": "Outer Rutherford County",
  "property_address_latitude": "35.9042471",
  "property_address_longitude": "-86.38613459999999",
  "property_email": "murfreesboro@alapts.com",
  "property_phone": "(615) 686-2414",
  "property_call_tracking_phone": "629-468-3381",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Modern Murfreesboro living starts at Parc.</strong> Explore polished one-, two-, and three-bedroom apartments with contemporary finishes, smart home features, and inviting spaces to unwind—then schedule your tour to see it all in person.</p>",
  "property_long_description": "<p><strong>Modern Murfreesboro living starts at Parc.</strong> Set along Memorial Boulevard in north Murfreesboro, Parc at Murfreesboro pairs polished one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with everyday convenience near Middle Tennessee State University, Stones River National Battlefield, and the shopping and dining around Medical Center Parkway.</p><p>Inside, you’ll find a clean, contemporary feel with stainless steel appliances, granite countertops, smart home technology, wood-style flooring, walk-in closets, and in-home washer and dryer connections. Around the community, your routine expands with a <a href=\"/amenities\">resort-style pool</a>, expansive sundeck, grilling area, two outdoor firepits, fitness center, yoga studio, coffee bar, game spaces, package lockers, EV charging, and elevators in every building.</p><p>When you want to get out, explore the Murfreesboro Greenway, browse more than 85 shops and restaurants at The Avenue Murfreesboro, or head toward downtown’s local dining and historic square. Parc makes it easy to enjoy a connected Murfreesboro address with room to settle in and recharge.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019d02f3-a799-70b3-ae7d-49c6c37e6b68.webp",
  "property_featured_image_media": {
    "alt_text": "Island kitchen with granite countertops, stainless steel dishwasher, and open living area.",
    "public_id": "019d02f3-a799-70b3-ae7d-49c6c37e6b68",
    "storage_key": "property/5757210235764736/019d02f3-a799-70b3-ae7d-49c6c37e6b68.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "359",
  "property_year_built": "2021",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.60724233983287",
  "property_admin_fee": "200",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $350 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $350 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8724090.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://parcatmurfreesboro.loftliving.com/login",
  "property_apply_now_url": "https://8724090.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e700d-cfd8-75c0-9c9a-cdb957df7550.webp",
  "property_primary_logo_media": {
    "alt_text": "Parc at Murfreesboro Premier Apartments logo.",
    "public_id": "019e700d-cfd8-75c0-9c9a-cdb957df7550",
    "storage_key": "property/5757210235764736/019e700d-cfd8-75c0-9c9a-cdb957df7550.webp",
    "width": 1349,
    "height": 601
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e700d-d047-73cb-a375-5bc4c6d2c32a.webp",
  "property_secondary_logo_media": {
    "alt_text": "Parc logo",
    "public_id": "019e700d-d047-73cb-a375-5bc4c6d2c32a",
    "storage_key": "property/5757210235764736/019e700d-d047-73cb-a375-5bc4c6d2c32a.webp",
    "width": 1134,
    "height": 430
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e700d-cf7f-71bf-99b1-ac1350728015.webp",
  "property_icon_media": {
    "alt_text": "Green P logo",
    "public_id": "019e700d-cf7f-71bf-99b1-ac1350728015",
    "storage_key": "property/5757210235764736/019e700d-cf7f-71bf-99b1-ac1350728015.webp",
    "width": 637,
    "height": 637
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e700d-cf7f-71bf-99b1-ac1350728015.webp",
  "property_fav_icon_media": {
    "alt_text": "Green P logo",
    "public_id": "019e700d-cf7f-71bf-99b1-ac1350728015",
    "storage_key": "property/5757210235764736/019e700d-cf7f-71bf-99b1-ac1350728015.webp",
    "width": 637,
    "height": 637
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e700d-cfd1-7748-9de7-1c34123b392b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Parc at Murfreesboro Premier Apartments logo",
    "public_id": "019e700d-cfd1-7748-9de7-1c34123b392b",
    "storage_key": "property/5757210235764736/019e700d-cfd1-7748-9de7-1c34123b392b.webp",
    "width": 1134,
    "height": 430
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019d02f4-ee9b-71cc-b382-a4223f12adb4.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Parc at Murfreesboro Premier Apartments logo",
    "public_id": "019d02f4-ee9b-71cc-b382-a4223f12adb4",
    "storage_key": "property/5757210235764736/019d02f4-ee9b-71cc-b382-a4223f12adb4.webp",
    "width": 325,
    "height": 123
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#155408",
  "property_secondary_color": "#0d0c42",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#83b473",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "686 - 1403",
  "property_sqft_min": "686",
  "property_sqft_max": "1403",
  "property_price_range": "1362.33 - 2515.33",
  "property_price_min": "1362.33",
  "property_price_max": "2515.33",
  "property_available_units": 5,
  "property_facebook_url": "https://www.facebook.com/parcatmurfreesboro",
  "property_instagram_url": "https://www.instagram.com/parcatmurfreesboro",
  "property_twitter_url": "https://twitter.com/parcatmurf",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJbZCTUlIGZIgR82HZCIISDw0",
  "property_youtube_url": "https://www.youtube.com/watch?v=L7vo5Neqx04",
  "property_yelp_url": "https://www.yelp.com/biz/panther-creek-parc-panther-residential-management-murfreesboro",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Downtime looks good from here.</strong> Start in the fitness center or yoga studio, stretch out by the resort-style pool and sundeck, then stay awhile with grills, outdoor games, and firepits. Inside, enjoy a lounge, gaming room, coffee bar, WiFi, and package lockers—plus apartment finishes like smart home technology, stainless steel appliances, granite countertops, wood-style flooring, walk-in closets, and in-home laundry.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to compare.</strong> Choose from one-, two-, and three-bedroom apartments at Parc at Murfreesboro, with open living areas, smart storage, and select patio, balcony, sunroom, or amenity-view options. Granite countertops, stainless steel appliances, smart home technology, wood-style flooring, walk-in closets, and full-size washers and dryers bring polished function to every layout.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life in sharper detail.</strong> Preview bright interiors, granite-topped kitchens, stainless steel appliances, open layouts, and select homes with sunrooms or private outdoor space. Then take in the resort-style pool, sundeck, firepit areas, grilling spaces, fitness center, yoga studio, coffee bar, gaming room, Bark Park, and pet spa—just a glimpse of what’s waiting in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>North Murfreesboro keeps the map easy.</strong> Set along Memorial Boulevard, Parc at Murfreesboro puts daily essentials, coffee runs, and dinner plans close by, with quick connections to Medical Center Parkway, The Avenue, and the historic Public Square.</p><p>For fresh air, explore nearby Murfreesboro Greenway trailheads or Stones River National Battlefield, then come home to a location that makes everyday plans feel simple.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents say Parc makes home feel easy.</strong> Reviews highlight friendly, helpful service, clear communication, and a smooth application process—plus the everyday details that stand out: brand-new styling, gray cabinetry, hardwood floors, stainless-steel appliances, roomy closets, and in-home laundry.</p><p>From responsive maintenance to clean, quiet surroundings, beautiful amenities, nearby shopping, and a pet-friendly atmosphere, see why Parc at Murfreesboro earns such positive feedback.</p>",
  "property_neighborhood_blurb": "<p><strong>North Murfreesboro puts more within easy reach.</strong> From Parc at Murfreesboro, Memorial Boulevard keeps everyday stops simple while connecting you to the city’s best-loved pockets: the retail and dining energy around Medical Center Parkway, the local flavor of the historic Public Square, and the open-air trails of the Murfreesboro Greenway.</p><p>Pick up coffee or dinner close to home, spend an afternoon browsing The Avenue, or head downtown for restaurants, shops, and events surrounding the Rutherford County Courthouse. When you want room to roam, Stones River National Battlefield and nearby greenway trailheads add fresh-air options to the map. Come see how the location fits your routine, then <a href=\"/schedule-a-tour\">schedule a tour</a> to explore Parc in person.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces made for every version of downtime.</strong> At Parc at Murfreesboro, you can move from a morning workout in the fitness center or yoga studio to an easy afternoon by the resort-style pool, sundeck, grills, outdoor games, and firepits. Inside, the lounge, gaming room, coffee bar, common-area WiFi, and package lockers help keep daily routines smooth.</p><p>Your apartment adds the same sense of ease with smart home technology, stainless steel appliances, granite countertops, deep sinks with gooseneck faucets, wood-style flooring, walk-in closets, and in-home laundry. Select homes offer extras like built-in shelving, sunrooms, private patios or balconies, 9-foot ceilings, or amenity views. Browse the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the details up close.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make Parc at Murfreesboro home?</strong><br>Start your application online for a polished one-, two-, or three-bedroom apartment with modern finishes, smart home technology, and everyday conveniences designed to help you settle in and recharge.</p>",
  "property_contactus_blurb": "<p><strong>Questions about Parc at Murfreesboro?</strong><br>Connect with the leasing team for details on our modern one-, two-, and three-bedroom apartments, everyday conveniences, or directions to our Memorial Boulevard location. We’re here to help you take the next step.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Parc at Murfreesboro?</strong> Start here for quick answers about the community, leasing, apartment features, and everyday living along Memorial Boulevard. If you don’t see what you need, the leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that feels like yours.</strong> Parc at Murfreesboro gives you a focused mix of one-, two-, and three-bedroom apartment floor plans, so you can compare open living areas, bedroom separation, storage, and available outdoor or sunroom options at a glance. Inside, polished finishes help every layout feel considered—from granite countertops and stainless steel appliances to deep kitchen sinks with gooseneck faucets, smart home technology, wood-style flooring, walk-in closets, and full-size washers and dryers.</p><p>As you browse current availability, look for select homes with built-in shelving, private patios or balconies, amenity views, top-floor placement, or 9-foot ceilings. Want to see the finishes up close? Explore the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to walk through your preferred floor plan.</p>",
  "property_gallery_blurb": "<p><strong>See Parc at Murfreesboro in focus.</strong> Browse bright apartment interiors, polished kitchens with granite countertops and stainless steel appliances, open living spaces, and select homes with sunrooms or private outdoor space. Each image gives you a clearer feel for the finishes, flow, and everyday details behind the <a href=\"/floor-plans\">one-, two-, and three-bedroom layouts</a>.</p><p>Then look beyond your front door: a resort-style pool framed by lounge seating, a sundeck made for sunny afternoons, firepit areas, grilling spaces, a fitness center, yoga studio, coffee bar, gaming room, Bark Park, and pet spa. Start with the gallery, continue with <a href=\"/virtual-tours\">virtual tours</a>, and when you’re ready to see the spaces in person, <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Parc on the map.</strong> See available apartments in north Murfreesboro, then pan out to find nearby shopping, dining, greenway stops, and downtown destinations—all from a connected Memorial Boulevard address.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, zoomies, and post-walk cleanups.</strong> At Parc at Murfreesboro, pets are part of the everyday rhythm, with cat- and dog-friendly apartment homes, no weight limit, and space for up to two pets per home. On-site, your routine gets easier with a Bark Park for off-leash energy and a Pet Spa for rinsing muddy paws before you head back inside.</p><p>Beyond the community, Murfreesboro adds more ways to get outside with leashed greenway paths and city bark parks for a change of scenery. Browse our <a href=\"/amenities\">pet-friendly amenities</a>, see the spaces in the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to explore Parc with your pet’s routine in mind.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Parc?</strong> Share the polished apartment finishes, everyday convenience, and connected Murfreesboro setting with someone you know. Send a referral today and invite a friend to find their next one-, two-, or three-bedroom home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Parc.</strong><br>Handle the everyday details of modern Murfreesboro living in one convenient place. Log in to pay rent, submit maintenance requests, and manage your account—so you can get back to enjoying your connected Parc lifestyle.</p>",
  "property_reviews_blurb": "<p><strong>Hear what life at Parc feels like from the people who know it best.</strong> Reviews point to a community that makes moving feel straightforward, with transparent communication, a seamless application process, and a team residents describe as “super friendly and helpful.”</p><p>You’ll also see praise for the details that shape everyday comfort: brand-new apartment styling, gray cabinetry, hardwood floors, stainless-steel appliances, roomy closets with in-home laundry, and a clean, quiet setting. Residents call out responsive maintenance, beautiful amenities, shopping options close by, and a pet-friendly atmosphere that feels easy to enjoy. Read the reviews below to see why so many are happy to call Parc at Murfreesboro home.</p>",
  "property_created_at": "1750285785728",
  "property_scheduletour_blurb": "<p><strong>See Parc at Murfreesboro in person.</strong> Tour polished one-, two-, and three-bedroom layouts with granite countertops, stainless steel appliances, smart home technology, wood-style flooring, and walk-in closets—then picture your routine with the pool, sundeck, fitness spaces, coffee bar, and more just steps from home.</p>",
  "property_thankyou_blurb": "<p><strong>Thanks for reaching out to Parc at Murfreesboro.</strong><br>Your submission has been received, and the leasing team will follow up soon. In the meantime, picture modern Murfreesboro living with polished one-, two-, and three-bedroom layouts, contemporary finishes, and inviting community spaces designed for everyday convenience.</p>",
  "property_virtualtours_blurb": "<p><strong>Tour the spaces before you step through the door.</strong> Use the virtual tours to move through Parc at Murfreesboro at your own pace, from the full community view to the clubhouse, fitness center, and outdoor lounge. It is an easy way to picture how the shared spaces connect—and where you might spend time between workouts, coffee breaks, and evenings outside.</p><p>Then step inside two apartment walkthroughs: the 1BR Olympic Sunroom and the 2BR Shenandoah. Look for the details that matter in a real home search, including open living flow, kitchen finishes, natural light, storage, and the added flexibility of a sunroom. When you are ready to compare more options, browse <a href=\"/floor-plans\">available floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Parc in person.</p>",
  "property_copyright": "2025 All Rights Reserved. Parc At Murfreesboro",
  "property_seo_title_home": "Apartments for Rent in Murfreesboro, TN | Parc at Murfreesboro",
  "property_seo_description_home": "Parc at Murfreesboro offers 1, 2, and 3 bedroom apartments for rent in Murfreesboro, TN. Experience spacious layouts, smart home features, and amenities.",
  "property_seo_title_floorplans": "Floor Plans | 1, 2 & 3 Bedroom Apartments in Murfreesboro, TN",
  "property_seo_description_floorplans": "Explore our 1, 2, and 3 bedroom apartment floor plans at Parc at Murfreesboro. Designed with comfort, space, and modern finishes for your ideal lifestyle.",
  "property_seo_title_amenities": "Amenities | Murfreesboro, TN Apartments with Pool, Gym & More",
  "property_seo_description_amenities": "Discover premium amenities at Parc at Murfreesboro, including a resort-style pool, fitness center, outdoor firepits, coffee bar, and WiFi in shared spaces.",
  "property_seo_title_gallery": "Gallery | 1, 2 & 3 Bedroom Apartments in Murfreesboro, TN",
  "property_seo_description_gallery": "Browse photos of Parc at Murfreesboro’s modern apartments and community amenities. See why our Murfreesboro apartments are the perfect place to call home.",
  "property_seo_title_virtualtours": "Virtual Tours | Apartments in Murfreesboro, TN",
  "property_seo_description_virtualtours": "Take a virtual tour of Parc at Murfreesboro’s 1, 2, and 3 bedroom apartments. Explore floor plans, luxury finishes, and community amenities from anywhere.",
  "property_seo_title_interactivemap": "Interactive Map | Apartments Near Downtown Murfreesboro, TN",
  "property_seo_description_interactivemap": "Use our interactive map to explore Parc at Murfreesboro’s location, nearby dining, shopping, schools, and local attractions in the heart of Murfreesboro, TN.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments Near Downtown Murfreesboro, TN",
  "property_seo_description_neighborhood": "Live near the best of Murfreesboro, TN. Parc at Murfreesboro offers 1, 2, and 3 bedroom apartments close to dining, shopping, schools, and parks.",
  "property_seo_title_contact": "Contact Us | Apartments in Murfreesboro, TN",
  "property_seo_description_contact": "Reach out to learn more about Parc at Murfreesboro. Ask about availability, pricing, and our 1, 2, and 3 bedroom floor plans in Murfreesboro, TN.",
  "property_seo_title_faqs": "FAQ | Apartment Leasing Questions in Murfreesboro, TN",
  "property_seo_description_faqs": "Find answers to frequently asked questions about leasing 1, 2, and 3 bedroom apartments at Parc at Murfreesboro. ",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Murfreesboro, TN",
  "property_seo_description_reviews": "See what residents are saying about their experience at Parc at Murfreesboro. Discover why our 1, 2, and 3 bedroom apartments are a top choice in Murfreesboro, TN.",
  "property_seo_title_applynow": "Apply Now | 1, 2 & 3 Bedroom Apartments in Murfreesboro, TN",
  "property_seo_description_applynow": "Apply online for a 1, 2, or 3 bedroom apartment at Parc at Murfreesboro. Start your next chapter with luxury floor plans and amenities in Murfreesboro, TN.",
  "property_seo_title_residentaccess": "Resident Access | Murfreesboro, TN Apartments",
  "property_seo_description_residentaccess": "Log in to your resident portal to pay rent, submit maintenance requests, and stay connected. Parc at Murfreesboro offers easy 24/7 online access.",
  "property_seo_title_referafriend": "Refer a Friend | Murfreesboro, TN Apartment Community",
  "property_seo_description_referafriend": "Love where you live? Refer a friend to Parc at Murfreesboro and share the benefits of our 1, 2, and 3 bedroom apartments and vibrant community.",
  "property_seo_title_scheduletour": "Schedule a Tour | Murfreesboro, TN Apartments for Rent",
  "property_seo_description_scheduletour": "Book your in-person or virtual tour of Parc at Murfreesboro today. View available 1, 2, and 3 bedroom apartments and explore our amenities and location.",
  "property_seo_title_privacy": "Privacy Policy | Parc at Murfreesboro Apartments",
  "property_seo_description_privacy": "Review the privacy policy for Parc at Murfreesboro to understand how your information is collected, stored, and used when browsing or submitting forms online.",
  "property_seo_title_accessibility": "Accessibility | Parc at Murfreesboro Website Accessibility",
  "property_seo_description_accessibility": "Parc at Murfreesboro is committed to digital accessibility. Learn how we ensure our apartment website is user-friendly and accessible to all visitors.",
  "property_seo_title_sitemap": "Sitemap | Parc at Murfreesboro Apartments in Murfreesboro, TN",
  "property_seo_description_sitemap": "Browse the full sitemap for Parc at Murfreesboro to find pages for floor plans, amenities, virtual tours, contact info, and more—all in one place.",
  "property_seo_title_thankyou": " Thank You | Apartments in Murfreesboro, TN",
  "property_seo_description_thankyou": "Thank you for your interest in our 1, 2, and 3 bedroom apartments in Murfreesboro, TN. A member of our leasing team will be in touch with you shortly.",
  "property_seo_title_pets": "Pet Policy | Apartments in Summerville, SC\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320124",
  "amenities": [
    {
      "id": "custom_f8549060-d8a2-41e8-8c36-412fb673fbcf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Granite Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00d0e65f-869a-485c-87ac-5bbde7c4bbda",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_07523a8f-497c-4c8c-92c2-780e6b14bea1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31f3ebf7-a265-4a8e-a51c-4d539cda5f5a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_153887fa-c405-47e8-bc70-d28469cf609b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000604",
      "title": "Built-In Bookcase",
      "amount": "0.0000",
      "description": "Built-In Shelving*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3d6a682-25d0-4740-a633-9dcb147773c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patios and Balconies*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4fe0867-d2f8-4a9d-afb9-1d6965d28692",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000691",
      "title": "Technology Package",
      "amount": "0.0000",
      "description": "Smart Home Technology",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_737da27e-5180-4156-9330-29db7b520b85",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000666",
      "title": "Pantry Closets",
      "amount": "0.0000",
      "description": "Kitchen Pantry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa937521-b7df-4bc1-a346-c54db8db39f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000676",
      "title": "Sink",
      "amount": "0.0000",
      "description": "Deep Kitchen Sinks w/ Gooseneck Faucets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e252ad3-ba35-42b9-b7d8-a489177b0ad0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000689",
      "title": "Sunroom",
      "amount": "0.0000",
      "description": "Sunrooms*",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_86de400d-2016-4b01-ba01-885767c39fe5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2a60a8ad-2f3e-41cb-be63-fd944db804ac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000695",
      "title": "Tile Backsplash",
      "amount": "0.0000",
      "description": "Decorative Tile Backsplash",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eafe4c8c-7e94-43df-9e41-c0780fe54775",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_34fc9dee-8adb-42ec-886d-f60ebbc97a5a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000675",
      "title": "Select Homes",
      "amount": "0.0000",
      "description": "*In Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1fbb0ec3-d046-4e53-acae-76443ede5580",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Style Swimming Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c021f2c7-cb7f-4d50-8e31-5551ae706861",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000626",
      "title": "Dog Park",
      "amount": "0.0000",
      "description": "Bark Park for your Furry Friends",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_39e8d383-e242-4b1f-824f-1d330d001eef",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000610",
      "title": "Car Charging Stations",
      "amount": "0.0000",
      "description": "Electric Car Charging Stations",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c574a6b3-d5eb-4513-bf32-e266ae6f7106",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000712",
      "title": "Yoga Room",
      "amount": "0.0000",
      "description": "Yoga Studio",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_00c81c31-8f79-4ada-bb11-932fc565b831",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000644",
      "title": "Grill Area",
      "amount": "0.0000",
      "description": "Outdoor Grilling Area",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b4531518-aef8-4796-81b6-c0b23679ac67",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7a3e69d1-9ad8-4a44-93d3-037fc3e17b90",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000002472",
      "title": "Pet Spa",
      "amount": "0.0000",
      "description": "Pet Spa",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5878e2b1-ff86-49b2-8230-dd5d614eae06",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000708",
      "title": "Wifi",
      "amount": "0.0000",
      "description": "Common Area WiFi Access",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81de807b-1ad3-4e86-b30f-de3a526d27da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000639",
      "title": "Game Room",
      "amount": "0.0000",
      "description": "Community Gaming Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1500795-a969-4cf0-91df-d1462210b4e9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000145",
      "title": "LUXER Package Locker",
      "amount": "0.0000",
      "description": "Parcel Pending Package Lockers",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_80d38998-b93b-4e13-8723-4dea8de8b84a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000634",
      "title": "Fire Pit",
      "amount": "0.0000",
      "description": "2 Outdoor Firepits",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da288c4a-64c6-4b65-a0bb-b02983231af2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000659",
      "title": "On Demand Fitness",
      "amount": "0.0000",
      "description": "Interactive Fitness Classes",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f85dd9ca-1691-42f1-b7bb-76e81193bd6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000615",
      "title": "Coffee Bar",
      "amount": "0.0000",
      "description": "Gourmet Coffee Bar",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_79d0ef0c-f812-44b0-8ee4-a797727c6652",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000661",
      "title": "Outdoor Gaming",
      "amount": "0.0000",
      "description": "Outdoor Gaming Including Bocce Ball & Cornhole",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7a22aee-18db-45bb-bbcb-fac253d292cd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000611",
      "title": "Car Wash",
      "amount": "0.0000",
      "description": "Community Car Care Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_937b428c-b251-4557-976b-85e1c85c0907",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000002458",
      "title": "Valet Trash Service",
      "amount": "0.0000",
      "description": "Valet Trash Service",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f02daaee-6255-480c-af99-4eaf97b440b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4a40bfa2-8042-4dd3-ac06-cf539cde7436",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_efc142b5-3f02-44da-9e42-e518b7acd253",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-9636-73f4-982c-0bf998bb4bf1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019e89a9-9636-73f4-982c-0bf998bb4bf1",
        "storage_key": "property/5757210235764736/019e89a9-9636-73f4-982c-0bf998bb4bf1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek white cabinetry, elegant granite countertops, and top-of-the-line stainless steel appliances. Perfect for culinary creations.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_11628ce2-368d-4166-ab58-646c0dbbf025",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-931d-705a-ab11-1f87b2832a5d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and stationary bikes.",
        "public_id": "019e89a9-931d-705a-ab11-1f87b2832a5d",
        "storage_key": "property/5757210235764736/019e89a9-931d-705a-ab11-1f87b2832a5d.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio machines.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, and stationary bikes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ea9a5c8e-69f9-4d91-97d6-a783e04e9028",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-91ee-769e-8c74-9ade83518742.webp",
      "image_media": {
        "alt_text": "Pool table and bar area in the community lounge.",
        "public_id": "019e89a9-91ee-769e-8c74-9ade83518742",
        "storage_key": "property/5757210235764736/019e89a9-91ee-769e-8c74-9ade83518742.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a friendly game of billiards in our stylish community lounge, complete with a full-service bar and ample seating for socializing.",
      "link": "",
      "alt_text": "Pool table and bar area in the community lounge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d766b0c9-f867-43cd-841a-0f26221cfdbc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-92ae-71fa-b947-34f78bd85663.webp",
      "image_media": {
        "alt_text": "Chalkboard with photos and grocery list next to shelves with decor, and a door leading to a bedroom.",
        "public_id": "019e89a9-92ae-71fa-b947-34f78bd85663",
        "storage_key": "property/5757210235764736/019e89a9-92ae-71fa-b947-34f78bd85663.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish chalkboard with a reminder for a photoshoot and a grocery list. Adjacent open shelving displays decorative items, adding a touch of warmth and organization to the apartment.",
      "link": "",
      "alt_text": "Chalkboard with photos and grocery list next to shelves with decor, and a door leading to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7495187f-1f4a-40af-9d8e-788d8e23d2d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-8e26-777e-a53b-868dc290f92a.webp",
      "image_media": {
        "alt_text": "Outdoor gathering space with a stone fireplace, modern lounge chairs, and a concrete table.",
        "public_id": "019e89a9-8e26-777e-a53b-868dc290f92a",
        "storage_key": "property/5757210235764736/019e89a9-8e26-777e-a53b-868dc290f92a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting outdoor lounge area, featuring a cozy stone fireplace and comfortable seating, perfect for enjoying pleasant evenings.",
      "link": "",
      "alt_text": "Outdoor gathering space with a stone fireplace, modern lounge chairs, and a concrete table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c1819f89-9708-44fe-9f83-5f623caa9b0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-8f6b-73bc-aa59-5531695019a4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, granite countertops, and a toilet. A bedroom is visible through the doorway.",
        "public_id": "019e89a9-8f6b-73bc-aa59-5531695019a4",
        "storage_key": "property/5757210235764736/019e89a9-8f6b-73bc-aa59-5531695019a4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Step into a pristine bathroom featuring a stylish white vanity with granite countertops, a comfortable toilet, and ample storage. Adjacent, a glimpse of the cozy bedroom awaits.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, granite countertops, and a toilet. A bedroom is visible through the doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60e860b0-8561-4441-92ad-bb07e96426c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-854c-772c-aede-c9232b02b7e4.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with plush sectional sofa, leather armchairs, and large windows.",
        "public_id": "019e89a9-854c-772c-aede-c9232b02b7e4",
        "storage_key": "property/5757210235764736/019e89a9-854c-772c-aede-c9232b02b7e4.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish and comfortable lounge area, featuring ample seating and natural light.",
      "link": "",
      "alt_text": "Spacious lounge area with plush sectional sofa, leather armchairs, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b078660a-3228-47f6-aa0e-a36f449c6c17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-82fb-76c3-ba09-dcb94bff922f.webp",
      "image_media": {
        "alt_text": "Bright and airy living room with a large sectional sofa, coffee table, TV, and decorative elements.",
        "public_id": "019e89a9-82fb-76c3-ba09-dcb94bff922f",
        "storage_key": "property/5757210235764736/019e89a9-82fb-76c3-ba09-dcb94bff922f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious and beautifully appointed living room, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Bright and airy living room with a large sectional sofa, coffee table, TV, and decorative elements.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_49a58f63-d8b8-4f1c-bf99-7031e29e879f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-832d-77a9-a3ac-bc35c8480d8b.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with grey siding and stone accents.",
        "public_id": "019e89a9-832d-77a9-a3ac-bc35c8480d8b",
        "storage_key": "property/5757210235764736/019e89a9-832d-77a9-a3ac-bc35c8480d8b.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Discover comfortable living in our stunning apartment community, featuring modern architecture and beautiful landscaping.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with grey siding and stone accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_68121ce1-c687-426d-ab9d-24e4a3d1752c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-871d-712f-bdf2-0abe19f7531f.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with granite countertops and stainless steel appliances.",
        "public_id": "019e89a9-871d-712f-bdf2-0abe19f7531f",
        "storage_key": "property/5757210235764736/019e89a9-871d-712f-bdf2-0abe19f7531f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and bright apartment featuring a modern kitchen with granite countertops and a comfortable living area, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen and living area with granite countertops and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21442f58-6120-4602-9edd-969b97fc7d91",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-77bc-742a-a7fc-ccdc30d9b748.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinetry, granite countertops, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019e89a9-77bc-742a-a7fc-ccdc30d9b748",
        "storage_key": "property/5757210235764736/019e89a9-77bc-742a-a7fc-ccdc30d9b748.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring white cabinets, sleek granite countertops, a stainless steel range and microwave, and a decorative backsplash. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinetry, granite countertops, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9dfb19fd-59a0-4f91-82b5-224238287b05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-711d-7548-b9cc-132a8704fa6c.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with chaise lounges and cabana by the pool at a luxury apartment complex.",
        "public_id": "019e89a9-711d-7548-b9cc-132a8704fa6c",
        "storage_key": "property/5757210235764736/019e89a9-711d-7548-b9cc-132a8704fa6c.webp",
        "width": 2868,
        "height": 1913
      },
      "title": "Community",
      "description": "Relax in style at our resort-style pool. Enjoy premium amenities like comfortable lounge chairs and private cabanas for the ultimate in relaxation and enjoyment.",
      "link": "",
      "alt_text": "Outdoor lounge area with chaise lounges and cabana by the pool at a luxury apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c450e978-554f-4b3d-b34a-c8a825de3954",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-740b-73d6-85f6-cd8945045f68.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019e89a9-740b-73d6-85f6-cd8945045f68",
        "storage_key": "property/5757210235764736/019e89a9-740b-73d6-85f6-cd8945045f68.webp",
        "width": 2732,
        "height": 1535
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, complete with comfortable lounge chairs and shaded areas. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cfa6a2ac-10ef-4399-b4ac-15e86a1720f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-7105-7179-86da-366d60aefbe7.webp",
      "image_media": {
        "alt_text": "Screened-in patio area with seating overlooking apartment buildings.",
        "public_id": "019e89a9-7105-7179-86da-366d60aefbe7",
        "storage_key": "property/5757210235764736/019e89a9-7105-7179-86da-366d60aefbe7.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy comfortable outdoor living in this beautifully appointed screened-in patio, perfect for relaxing or socializing with a view of the community.",
      "link": "",
      "alt_text": "Screened-in patio area with seating overlooking apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba51da33-94a5-4fff-afcb-d91727dd31b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-6f15-77ae-aa52-536adeab1b8c.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, toilet, walk-in closet, and glass shower.",
        "public_id": "019e89a9-6f15-77ae-aa52-536adeab1b8c",
        "storage_key": "property/5757210235764736/019e89a9-6f15-77ae-aa52-536adeab1b8c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Experience luxury in our apartment bathrooms, featuring elegant granite countertops, a spacious double vanity, and a convenient walk-in closet. Enjoy the spa-like walk-in shower.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, granite countertops, toilet, walk-in closet, and glass shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1484eb55-f7b8-4f1d-bc87-184e9c2b88c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-7201-77ce-a584-0381bee4c7ca.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and a view into the bathroom.",
        "public_id": "019e89a9-7201-77ce-a584-0381bee4c7ca",
        "storage_key": "property/5757210235764736/019e89a9-7201-77ce-a584-0381bee4c7ca.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a comfortable bed, ample closet space, and a connected bathroom, perfect for relaxation and modern living.",
      "link": "",
      "alt_text": "Bedroom with a closet and a view into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a4608659-0892-4d73-8094-bab6ab91297a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-6a29-7789-926d-baad4e4e96c6.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a long bar, leather stools, and a coffee station.",
        "public_id": "019e89a9-6a29-7789-926d-baad4e4e96c6",
        "storage_key": "property/5757210235764736/019e89a9-6a29-7789-926d-baad4e4e96c6.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy our stylish community lounge, featuring a contemporary bar area with comfortable seating and a convenient coffee station for residents.",
      "link": "",
      "alt_text": "Modern community lounge with a long bar, leather stools, and a coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f02cc814-cd16-4b25-8888-190778550013",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-6773-75bc-8ab2-785951c1eb59.webp",
      "image_media": {
        "alt_text": "Spin bikes and weights in a modern apartment complex gym",
        "public_id": "019e89a9-6773-75bc-8ab2-785951c1eb59",
        "storage_key": "property/5757210235764736/019e89a9-6773-75bc-8ab2-785951c1eb59.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, weight machines, and free weights.",
      "link": "",
      "alt_text": "Spin bikes and weights in a modern apartment complex gym",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1803cae0-2545-4ea7-bd42-bb3204e439e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-6925-762e-8208-f0ca107b3b44.webp",
      "image_media": {
        "alt_text": "Living room with a leather couch, coffee table, and large windows.",
        "public_id": "019e89a9-6925-762e-8208-f0ca107b3b44",
        "storage_key": "property/5757210235764736/019e89a9-6925-762e-8208-f0ca107b3b44.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish living room with a comfortable leather couch, vibrant rug, and ample natural light.",
      "link": "",
      "alt_text": "Living room with a leather couch, coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5de38f6b-f83e-4689-a0b8-0c5e5127e28f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-6624-7712-b12e-bfd1b494c09c.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, bathtub, and walk-in closet.",
        "public_id": "019e89a9-6624-7712-b12e-bfd1b494c09c",
        "storage_key": "property/5757210235764736/019e89a9-6624-7712-b12e-bfd1b494c09c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a granite countertop vanity, a deep soaking tub, a private toilet, and a spacious walk-in closet. The warm wood-look flooring and modern fixtures create a spa-like atmosphere.",
      "link": "",
      "alt_text": "Bathroom with a vanity, toilet, bathtub, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9531c3c2-c106-406b-8c18-e060aa416fd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-5492-715d-a160-f8d04105d69a.webp",
      "image_media": {
        "alt_text": "Spacious and modern apartment building lobby with seating areas and elegant decor.",
        "public_id": "019e89a9-5492-715d-a160-f8d04105d69a",
        "storage_key": "property/5757210235764736/019e89a9-5492-715d-a160-f8d04105d69a.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Experience the sophisticated ambiance of our apartment community's grand lobby. Designed for comfort and style, it offers inviting seating areas and refined decorative touches.",
      "link": "",
      "alt_text": "Spacious and modern apartment building lobby with seating areas and elegant decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2c155b2c-37f1-4be3-b623-e05d94da1310",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-4755-777f-aaeb-ebfd15913410.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating area.",
        "public_id": "019e89a9-4755-777f-aaeb-ebfd15913410",
        "storage_key": "property/5757210235764736/019e89a9-4755-777f-aaeb-ebfd15913410.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, featuring comfortable lounge chairs and an outdoor dining area perfect for enjoying the sunshine.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and outdoor seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7e52082-64b0-4108-b78c-4c18682c0db5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-44fd-726c-9a39-29a66e6aa289.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with grills and a TV",
        "public_id": "019e89a9-44fd-726c-9a39-29a66e6aa289",
        "storage_key": "property/5757210235764736/019e89a9-44fd-726c-9a39-29a66e6aa289.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy convenient outdoor grilling with built-in BBQs and entertainment options.",
      "link": "",
      "alt_text": "Outdoor kitchen with grills and a TV",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa46a7bb-131d-48bf-a069-4d3b0c1163c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-43cf-736c-a0d9-fb18db3e41d4.webp",
      "image_media": {
        "alt_text": "Modern communal lounge area with plush seating, abstract art, and large windows.",
        "public_id": "019e89a9-43cf-736c-a0d9-fb18db3e41d4",
        "storage_key": "property/5757210235764736/019e89a9-43cf-736c-a0d9-fb18db3e41d4.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed communal lounge. Featuring comfortable seating, stylish decor, and ample natural light, it's the perfect space to unwind or connect with neighbors.",
      "link": "",
      "alt_text": "Modern communal lounge area with plush seating, abstract art, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_56187be3-9a76-46ef-9c85-1ab31ad53471",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-4747-7792-beb9-4681f662995f.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with gray siding and stone accents.",
        "public_id": "019e89a9-4747-7792-beb9-4681f662995f",
        "storage_key": "property/5757210235764736/019e89a9-4747-7792-beb9-4681f662995f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stunning exterior view of the apartment building, showcasing its modern design with gray siding and elegant stone accents, set against a clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with gray siding and stone accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38794fc5-5b11-467c-a48a-3f31ee4c0a20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-49e6-730f-ae9e-49ed632879c5.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex pool and clubhouse on a clear day.",
        "public_id": "019e89a9-49e6-730f-ae9e-49ed632879c5",
        "storage_key": "property/5757210235764736/019e89a9-49e6-730f-ae9e-49ed632879c5.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool or relax by the fire pit. The perfect place to unwind and entertain.",
      "link": "",
      "alt_text": "Luxury apartment complex pool and clubhouse on a clear day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3c476dc1-42d9-4bd2-bb01-df5011030553",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-4996-7228-9400-6416b4c4e7ab.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with granite countertop and stainless steel dishwasher.",
        "public_id": "019e89a9-4996-7228-9400-6416b4c4e7ab",
        "storage_key": "property/5757210235764736/019e89a9-4996-7228-9400-6416b4c4e7ab.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with a granite countertop and a built-in dishwasher, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen island with granite countertop and stainless steel dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e008498a-e9a9-410d-a8ea-b89b2f1e3a14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-44ab-76b5-816d-f09f9f5ea28e.webp",
      "image_media": {
        "alt_text": "Modern lobby with a check-in desk, comfortable seating, and a striking accent wall.",
        "public_id": "019e89a9-44ab-76b5-816d-f09f9f5ea28e",
        "storage_key": "property/5757210235764736/019e89a9-44ab-76b5-816d-f09f9f5ea28e.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Step into our stylish lobby, featuring a welcoming check-in area, elegant seating, and a unique geometric accent wall. A perfect space to relax or conduct business.",
      "link": "",
      "alt_text": "Modern lobby with a check-in desk, comfortable seating, and a striking accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_57f84f0c-91f3-46e7-a4dd-27399bb754e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-4433-76ea-9fa8-318c17f8c412.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island, white cabinets, and stainless steel appliances.",
        "public_id": "019e89a9-4433-76ea-9fa8-318c17f8c412",
        "storage_key": "property/5757210235764736/019e89a9-4433-76ea-9fa8-318c17f8c412.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large granite island with a sink, white cabinetry, subway tile backsplash, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with granite island, white cabinets, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6703ee28-9006-44db-97e4-c871578c7668",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-4a2a-7305-9256-af33bf59b87f.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, white linens, and decorative pillows.",
        "public_id": "019e89a9-4a2a-7305-9256-af33bf59b87f",
        "storage_key": "property/5757210235764736/019e89a9-4a2a-7305-9256-af33bf59b87f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable king-size bed with crisp white linens.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, white linens, and decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8bb7f5f0-fd06-4497-8bb8-78da4941ec85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-2873-71ba-8685-8c5a1680ed28.webp",
      "image_media": {
        "alt_text": "Modern coffee and beverage station with a sleek stainless steel machine, touch screen, and a mini-fridge.",
        "public_id": "019e89a9-2873-71ba-8685-8c5a1680ed28",
        "storage_key": "property/5757210235764736/019e89a9-2873-71ba-8685-8c5a1680ed28.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy a variety of complimentary beverages from our state-of-the-art coffee station, complete with a mini-fridge for your convenience.",
      "link": "",
      "alt_text": "Modern coffee and beverage station with a sleek stainless steel machine, touch screen, and a mini-fridge.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_15c89e12-0c5b-4ce5-8cf6-22f581e1ee87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-1161-76d3-9e50-df022cf6588f.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, patterned accent wall, and large windows.",
        "public_id": "019e89a9-1161-76d3-9e50-df022cf6588f",
        "storage_key": "property/5757210235764736/019e89a9-1161-76d3-9e50-df022cf6588f.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a stylish accent wall, and abundant natural light from large windows.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, patterned accent wall, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3f64ee1d-39c0-4d74-bad6-9236537707a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-1141-72b9-a4dd-dfaff798bca7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with sun loungers and lounge chairs, with apartment buildings in the background.",
        "public_id": "019e89a9-1141-72b9-a4dd-dfaff798bca7",
        "storage_key": "property/5757210235764736/019e89a9-1141-72b9-a4dd-dfaff798bca7.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Relax by our sparkling outdoor swimming pool, complete with comfortable sun loungers and lounge chairs. The perfect place to unwind and soak up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with sun loungers and lounge chairs, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e5e465f-6a42-4693-a892-1997eb69741e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019e89a9-1622-71b3-b5db-f6f36f563ac1.webp",
      "image_media": {
        "alt_text": "Closet with shelving, baskets, hangers, and a white robe.",
        "public_id": "019e89a9-1622-71b3-b5db-f6f36f563ac1",
        "storage_key": "property/5757210235764736/019e89a9-1622-71b3-b5db-f6f36f563ac1.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Organized closet space with ample shelving, baskets, and hangers, featuring a plush white robe for added comfort.",
      "link": "",
      "alt_text": "Closet with shelving, baskets, hangers, and a white robe.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_5db2d26c5f5f207c6a2477dd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Primrose Table",
      "poi_type": "Restaurants",
      "poi_address": "1650 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Comfortable, upscale locale serving comfort food, plus craft beer, cocktails, and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-836f-720d-9415-6a0c4a6fe783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-836f-720d-9415-6a0c4a6fe783",
        "storage_key": "property/5757210235764736/019f14ff-836f-720d-9415-6a0c4a6fe783.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "http://www.primrosetable.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5596778000895118977&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-table",
      "poi_latitude": "35.865819",
      "poi_longitude": "-86.3871025",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-900-5790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxd5ouIHZIgRgQ4TVvC_q00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_54e3751e6046e500c223c25f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Koji Express Japanese Grill - Memorial",
      "poi_type": "Restaurants",
      "poi_address": "1010 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Fast-food hibachi joint whips up hearty plates of familiar Japanese grub, to dine-in or drive-thru.",
      "poi_long_description": "Fast-food hibachi joint whips up hearty plates of familiar Japanese grub, to dine-in or drive-thru.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-8b42-73af-80f0-b3e5bb6d1d57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-8b42-73af-80f0-b3e5bb6d1d57",
        "storage_key": "property/5757210235764736/019f14ff-8b42-73af-80f0-b3e5bb6d1d57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.kojiexpress.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18303989275350406194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "koji-express-japanese-grill---memorial",
      "poi_latitude": "35.8581818",
      "poi_longitude": "-86.3921781",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-907-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFy9BjHb4Y4gRMhTSaUTVBP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_b2f08165d93d59fd9ea376ec",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Camino Real - Memorial",
      "poi_type": "Restaurants",
      "poi_address": "3359 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Popular Mexican dishes, such as burritos & fajitas, served up in a relaxed setting.",
      "poi_long_description": "Popular Mexican dishes, such as burritos & fajitas, served up in a relaxed setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-8ae5-75e1-bea1-e83dea58c425.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-8ae5-75e1-bea1-e83dea58c425",
        "storage_key": "property/5757210235764736/019f14ff-8ae5-75e1-bea1-e83dea58c425.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://memorial.caminorealmexicanrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1674965968775231620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camino-real---memorial",
      "poi_latitude": "35.9088147",
      "poi_longitude": "-86.3843816",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 615-907-8778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD4Vc6lMGZIgRhDi3m6ysPhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_207696643360c158c06f996b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "2105 Memorial Blvd Ste A, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-88da-72b8-a839-f6ca6b05a717.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-88da-72b8-a839-f6ca6b05a717",
        "storage_key": "property/5757210235764736/019f14ff-88da-72b8-a839-f6ca6b05a717.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/tn/murfreesboro/2105-memorial-blvd?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=606030&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=17952317830531656064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "35.8803076",
      "poi_longitude": "-86.3845455",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 615-995-7639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a01-744d-ab13-bb35632918eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a01-744d-ab13-bb35632918eb",
        "storage_key": "property/5757210235764736/019f1500-2a01-744d-ab13-bb35632918eb.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJp4E0HZAHZIgRgCnAj_NxI_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_4141d1b53cb1a15189a0d098",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "2113 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-8a76-7083-9bdf-a9a1476af876.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-8a76-7083-9bdf-a9a1476af876",
        "storage_key": "property/5757210235764736/019f14ff-8a76-7083-9bdf-a9a1476af876.webp",
        "width": 1280,
        "height": 947
      },
      "poi_business_url": "https://locations.chipotle.com/tn/murfreesboro/2113-memorial-blvd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=15295805725631958429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "35.8811727",
      "poi_longitude": "-86.3844106",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 615-439-6117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6NIukwHZIgRnc2tTUSeRdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_97f5a8bf4232d3e160f9a895",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "The Clay Pit Indian STREET FOOD",
      "poi_type": "Restaurants",
      "poi_address": "1813 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Straightforward Indian restaurant serving familiar favorites off a menu or from an all-day buffet.",
      "poi_long_description": "Straightforward Indian restaurant serving familiar favorites off a menu or from an all-day buffet.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-8a6d-741a-b50b-426830c66f5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-8a6d-741a-b50b-426830c66f5c",
        "storage_key": "property/5757210235764736/019f14ff-8a6d-741a-b50b-426830c66f5c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5649554713977489039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-clay-pit-indian-street-food",
      "poi_latitude": "35.8716543",
      "poi_longitude": "-86.3860753",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-904-6262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSc_mK4UHZIgRjwbDaRRAZ04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "ec_ed8b338beac00762912a9628",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Jonathan's Grille",
      "poi_type": "Restaurants",
      "poi_address": "2911 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Casual eatery featuring beer on tap, pizzas and burgers on the menu, along with a bar and multiple TVs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-8709-727a-87bf-9b2bd765097e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-8709-727a-87bf-9b2bd765097e",
        "storage_key": "property/5757210235764736/019f14ff-8709-727a-87bf-9b2bd765097e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://jonathansgrille.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3175185824886931432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jonathans-grille",
      "poi_latitude": "35.8654757",
      "poi_longitude": "-86.4482866",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-410-7960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a08-7190-afe1-bd3715f9fd18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a08-7190-afe1-bd3715f9fd18",
        "storage_key": "property/5757210235764736/019f1500-2a08-7190-afe1-bd3715f9fd18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsZb2SyYIZIgR6L89VK-GECw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "ec_aa11058730d9ac99fc0c61e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Steakhouse Five",
      "poi_type": "Restaurants",
      "poi_address": "1500 Medical Center Pkwy #1k, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Upscale spot with a chic ambiance for steaks, plus wine and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-8312-7458-8f33-8e30f0e09fa3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-8312-7458-8f33-8e30f0e09fa3",
        "storage_key": "property/5757210235764736/019f14ff-8312-7458-8f33-8e30f0e09fa3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://steakhousefive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12089126525034631934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steakhouse-five",
      "poi_latitude": "35.8609646",
      "poi_longitude": "-86.4170542",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-396-3225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0R2KZP5Y4gR_hJxCYY0xac",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_322f4c1cbab7755b0f56e3d6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Five Senses Restaurant, Bar & Catering",
      "poi_type": "Restaurants",
      "poi_address": "1602 W Northfield Blvd #515, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Inventive, seasonal New American cuisine & cocktails offered in vibrant, industrial-chic surrounds.",
      "poi_long_description": "Inventive, seasonal New American cuisine & cocktails offered in vibrant, industrial-chic surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-8368-70ec-b1c5-0048f15f91e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-8368-70ec-b1c5-0048f15f91e3",
        "storage_key": "property/5757210235764736/019f14ff-8368-70ec-b1c5-0048f15f91e3.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.fivesensesdining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6583107978001035513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-senses-restaurant-bar--catering",
      "poi_latitude": "35.8720221",
      "poi_longitude": "-86.4140984",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 615-410-7409",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOYc5avsHZIgR-bDKwtPlW1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_8d70c355b3c190ddad7a351a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Firehouse Subs Memorial Blvd",
      "poi_type": "Restaurants",
      "poi_address": "2445 Memorial Blvd A, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_long_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-8300-76a6-bdc7-a0bdb331b6ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-8300-76a6-bdc7-a0bdb331b6ae",
        "storage_key": "property/5757210235764736/019f14ff-8300-76a6-bdc7-a0bdb331b6ae.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://www.firehousesubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13915392548302736544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firehouse-subs-memorial-blvd",
      "poi_latitude": "35.888141",
      "poi_longitude": "-86.38275709999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-962-8051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHzSk3fsHZIgRoMyzt8tnHcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "ec_16f621c02af80b730c81109e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "3250A Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-8f9f-745e-83c1-debabd9aea9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-8f9f-745e-83c1-debabd9aea9b",
        "storage_key": "property/5757210235764736/019f14ff-8f9f-745e-83c1-debabd9aea9b.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/tn/murfreesboro/3250a-memorial-blvd/359021?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=359021&y_source=1_MTQwMzYzOTUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6937470044787445732&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "35.9047262",
      "poi_longitude": "-86.3829818",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 615-203-6683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a01-744d-ab13-bb35632918eb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a01-744d-ab13-bb35632918eb",
        "storage_key": "property/5757210235764736/019f1500-2a01-744d-ab13-bb35632918eb.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJwRggQ70HZIgR5A942z_YRmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_875c3640ec9953945e4291f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Wendy's",
      "poi_type": "Restaurants",
      "poi_address": "3243 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-90c8-7278-8d46-7263b4b2cd6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-90c8-7278-8d46-7263b4b2cd6b",
        "storage_key": "property/5757210235764736/019f14ff-90c8-7278-8d46-7263b4b2cd6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.wendys.com/united-states/tn/murfreesboro/3243-memorial-blvd?utm_source=Yext&utm_medium=Google_My_Business&utm_campaign=Local_Search&utm_content=EN_US",
      "poi_directions_map_url": "https://maps.google.com/?cid=1403726798995865829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wendys",
      "poi_latitude": "35.9039404",
      "poi_longitude": "-86.3838959",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 615-413-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7cyOYeUHZIgR5UDYHxYKexM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "ec_724efd0ceef50272cf8a9a08",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "The Alley on Main",
      "poi_type": "Restaurants",
      "poi_address": "223 W Main St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Steaks, seafood, pastas & sandwiches served in a relaxed space with a full bar & homemade desserts.",
      "poi_long_description": "Steaks, seafood, pastas & sandwiches served in a relaxed space with a full bar & homemade desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-91e9-714b-ba53-e3058eb9280b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-91e9-714b-ba53-e3058eb9280b",
        "storage_key": "property/5757210235764736/019f14ff-91e9-714b-ba53-e3058eb9280b.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.alleyonmain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17902699357648639824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alley-on-main",
      "poi_latitude": "35.8459759",
      "poi_longitude": "-86.3937492",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-203-3498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YgiGWz4Y4gRUNdClTYqc_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_96652edc1df507df3173e524",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Marina's on the Square",
      "poi_type": "Restaurants",
      "poi_address": "125 N Maple St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Italian pastas & pizzas draw crowds to this eatery in an historic brick building with big windows.",
      "poi_long_description": "Italian pastas & pizzas draw crowds to this eatery in an historic brick building with big windows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-9129-7465-ac70-fd4e77a034f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-9129-7465-ac70-fd4e77a034f5",
        "storage_key": "property/5757210235764736/019f14ff-9129-7465-ac70-fd4e77a034f5.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.marinasonthesquare.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15354684727221358173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marinas-on-the-square",
      "poi_latitude": "35.8469976",
      "poi_longitude": "-86.3928736",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-849-8881",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJbs_hW74Y4gRXQ4lJGjMFtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_c6dd402952a5f4858835bff0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Buster's Place",
      "poi_type": "Restaurants",
      "poi_address": "1615 NW Broad St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Established in 1973, this burger joint offers wings, chili & classic sides, plus a full bar.",
      "poi_long_description": "Established in 1973, this burger joint offers wings, chili & classic sides, plus a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-942e-7748-a773-b55ca531b8ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-942e-7748-a773-b55ca531b8ee",
        "storage_key": "property/5757210235764736/019f14ff-942e-7748-a773-b55ca531b8ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.bustersintheboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16589492609046079730&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "busters-place",
      "poi_latitude": "35.8698055",
      "poi_longitude": "-86.4164594",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-895-5464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64d8-741a-89f2-d38f1a568f3c",
        "storage_key": "property/5757210235764736/019f14fd-64d8-741a-89f2-d38f1a568f3c.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQeDhrv0HZIgR8ugoDqK3OeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_7ea625b686999f897d84e9fd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "3267 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-968b-73d7-a069-a54fa049ebdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-968b-73d7-a069-a54fa049ebdc",
        "storage_key": "property/5757210235764736/019f14ff-968b-73d7-a069-a54fa049ebdc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tn/murfreesboro/3267-memorial-blvd/l247",
      "poi_directions_map_url": "https://maps.google.com/?cid=2571838853974138591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.905647",
      "poi_longitude": "-86.384613",
      "poi_miles_from_property": "190 ft",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64ee-77ce-b5d0-9baa8385920e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64ee-77ce-b5d0-9baa8385920e",
        "storage_key": "property/5757210235764736/019f14fd-64ee-77ce-b5d0-9baa8385920e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYZS7j0HZIgR3x6tvs8BsSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_7877d0abffc3d50088804df4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "2325 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-930c-705d-8757-9e27ca9204ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-930c-705d-8757-9e27ca9204ef",
        "storage_key": "property/5757210235764736/019f14ff-930c-705d-8757-9e27ca9204ef.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tn/murfreesboro/irongate-village/026/00539?cid=loc_02600539_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12119813431682735006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "35.886501",
      "poi_longitude": "-86.384543",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-867-2216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64ee-77ce-b5d0-9baa8385920e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64ee-77ce-b5d0-9baa8385920e",
        "storage_key": "property/5757210235764736/019f14fd-64ee-77ce-b5d0-9baa8385920e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOS_xxKMHZIgRnht1Qxo6Mqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_966e1b65a8b15ee2501bb71b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2012 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Wide-ranging supermarket chain selling groceries and a bakery, plus appliances, electronics, auto parts and furniture.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-9691-77ea-a324-d141e43e131a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-9691-77ea-a324-d141e43e131a",
        "storage_key": "property/5757210235764736/019f14ff-9691-77ea-a324-d141e43e131a.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2757-murfreesboro-tn/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11691891774682680471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.878498",
      "poi_longitude": "-86.3830413",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-995-7092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6422-7678-9375-0722122d1a41",
        "storage_key": "property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA_M935sHZIgRl8xFbp_xQaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_b111ca6febcd5faf28dc3ca3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Publix Super Market at North Murfreesboro",
      "poi_type": "Shopping & Retail",
      "poi_address": "3415 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-969d-74f4-8735-788bb8591103.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-969d-74f4-8735-788bb8591103",
        "storage_key": "property/5757210235764736/019f14ff-969d-74f4-8735-788bb8591103.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1164&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=15638332244674995959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-north-murfreesboro",
      "poi_latitude": "35.9121189",
      "poi_longitude": "-86.3860907",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 615-849-6254",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64ee-77ce-b5d0-9baa8385920e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64ee-77ce-b5d0-9baa8385920e",
        "storage_key": "property/5757210235764736/019f14fd-64ee-77ce-b5d0-9baa8385920e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2R7oN1EGZIgR9-ZjM1KEBtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_165168517c244c4117a41e1d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1331 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-9771-7409-a1ff-621ad7ba3016.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-9771-7409-a1ff-621ad7ba3016",
        "storage_key": "property/5757210235764736/019f14ff-9771-7409-a1ff-621ad7ba3016.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/murfreesboro-tn-pharmacies/1331-memorial-blvd-murfreesboro-tn-37129/storeid=6420?WT.mc_id=LS_GOOGLE_RX_6420",
      "poi_directions_map_url": "https://maps.google.com/?cid=598746042423419551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.8612744",
      "poi_longitude": "-86.3909621",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-893-8887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a08-7190-afe1-b9a878c9e1f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a08-7190-afe1-b9a878c9e1f8",
        "storage_key": "property/5757210235764736/019f1500-2a08-7190-afe1-b9a878c9e1f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlzpu1YkHZIgRn6JRcVosTwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_ebb64a1759262a44b558ca58",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3389 Memorial Blvd Walgreens, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-9e00-77e9-990c-a56701b07e2a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-9e00-77e9-990c-a56701b07e2a",
        "storage_key": "property/5757210235764736/019f14ff-9e00-77e9-990c-a56701b07e2a.webp",
        "width": 1280,
        "height": 1160
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3389+memorial+blvd-murfreesboro-tn-37129/id=6693",
      "poi_directions_map_url": "https://maps.google.com/?cid=10210951867325424899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.9099885",
      "poi_longitude": "-86.38438219999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 615-867-6720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGXRlX1EGZIgRAyWLlp-WtI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_6b3af0c3d3dafc51aeed4f63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Rite Aid",
      "poi_type": "Shopping & Retail",
      "poi_address": "2485 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-988f-75a0-8ad7-541552d8840a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-988f-75a0-8ad7-541552d8840a",
        "storage_key": "property/5757210235764736/019f14ff-988f-75a0-8ad7-541552d8840a.webp",
        "width": 251,
        "height": 250
      },
      "poi_business_url": "https://locations.riteaid.com/locations/tn/murfreesboro/2485-memorial-blvd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=637760583025324967&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rite-aid",
      "poi_latitude": "35.8890647",
      "poi_longitude": "-86.3828427",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-904-9907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfSmLuaYHZIgRp3P4Ct_H2Qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_e2e67786c912fb6ffc461d63",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Speedway",
      "poi_type": "Shopping & Retail",
      "poi_address": "2908 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-9ee7-75fd-9d39-773d08263ce1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-9ee7-75fd-9d39-773d08263ce1",
        "storage_key": "property/5757210235764736/019f14ff-9ee7-75fd-9d39-773d08263ce1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.speedway.com/locations/TN/Murfreesboro/2908-Memorial-Blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=10182391735083376396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "speedway",
      "poi_latitude": "35.8976136",
      "poi_longitude": "-86.38263520000001",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 615-907-8922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a00-715a-87f5-14d6166865cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a00-715a-87f5-14d6166865cb",
        "storage_key": "property/5757210235764736/019f1500-2a00-715a-87f5-14d6166865cb.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWyPNKkHZIgRDJ-EnVUfT40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_6ff6cd330bdc3258de63c8eb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Stones River Town Centre",
      "poi_type": "Shopping & Retail",
      "poi_address": "1720 Old Fort Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Indoor site with fashion & accessory chains, personal care, dining, kids' activities & movies.",
      "poi_long_description": "Indoor site with fashion & accessory chains, personal care, dining, kids' activities & movies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-a04c-7211-bd02-833ce212ce85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-a04c-7211-bd02-833ce212ce85",
        "storage_key": "property/5757210235764736/019f14ff-a04c-7211-bd02-833ce212ce85.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.shopstonesriver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=106645893605734169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stones-river-town-centre",
      "poi_latitude": "35.8480189",
      "poi_longitude": "-86.4175283",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-896-4486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6422-7678-9375-0722122d1a41",
        "storage_key": "property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9_Wm1ff3Y4gRGbcfDeDhegE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_adf212e14990985dfa34f37e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "The Avenue Murfreesboro",
      "poi_type": "Shopping & Retail",
      "poi_address": "2615 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Large outdoor shopping center with landscaped walkways, ample parking & varied restaurants.",
      "poi_long_description": "Large outdoor shopping center with landscaped walkways, ample parking & varied restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-11aa-7475-9bc9-1893a23b7b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-11aa-7475-9bc9-1893a23b7b2b",
        "storage_key": "property/5757210235764736/019f14fd-11aa-7475-9bc9-1893a23b7b2b.webp",
        "width": 1024,
        "height": 680
      },
      "poi_business_url": "https://theavenuemurfreesboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4544059927879211805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-avenue-murfreesboro",
      "poi_latitude": "35.8584298",
      "poi_longitude": "-86.44513959999999",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-893-4207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6422-7678-9375-0722122d1a41",
        "storage_key": "property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOeRiMNn3Y4gRHdtTz22-Dz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_63241f6bea592388bf3e2365",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Northfield Elementary School",
      "poi_type": "Education",
      "poi_address": "550 W Northfield Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.northfieldelementary.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16104218775364529448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northfield-elementary-school",
      "poi_latitude": "35.8749622",
      "poi_longitude": "-86.39288359999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-895-7324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbXu-dpEHZIgRKG3HAqetfd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_cda1fad04e681fd29f62e4ed",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Siegel Middle School",
      "poi_type": "Education",
      "poi_address": "355 W Thompson Ln, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-ad3d-77f3-9a8d-306ae7b3efee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-ad3d-77f3-9a8d-306ae7b3efee",
        "storage_key": "property/5757210235764736/019f14ff-ad3d-77f3-9a8d-306ae7b3efee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sim.rcschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2429484348357891796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "siegel-middle-school",
      "poi_latitude": "35.9100153",
      "poi_longitude": "-86.3961547",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-904-3830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ2tiYUkGZIgR1FY-kyRDtyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_78d95ad9bef6eedfc88b3a3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Siegel High School",
      "poi_type": "Education",
      "poi_address": "3300 Siegel Rd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-aa95-73de-a229-3114373069bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-aa95-73de-a229-3114373069bc",
        "storage_key": "property/5757210235764736/019f14ff-aa95-73de-a229-3114373069bc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sgh.rcschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9653343831697650441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "siegel-high-school",
      "poi_latitude": "35.9076488",
      "poi_longitude": "-86.4013238",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-904-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkRqzny4HZIgRCfMLvxGR94U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_110aa6d0d7e255614eedb616",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Middle Tennessee State University",
      "poi_type": "Education",
      "poi_address": "1301 E Main St, Murfreesboro, TN 37132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-1e3a-75ca-be8b-eb6b2b4a9bdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-1e3a-75ca-be8b-eb6b2b4a9bdc",
        "storage_key": "property/5757210235764736/019f14fd-1e3a-75ca-be8b-eb6b2b4a9bdc.webp",
        "width": 1158,
        "height": 478
      },
      "poi_business_url": "https://www.mtsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12390517612238132658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-tennessee-state-university",
      "poi_latitude": "35.8486229",
      "poi_longitude": "-86.36691549999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-898-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpcKjWZf4Y4gRstWs3B7286s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_03bb3f451a419c544d995913",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Tennessee College of Applied Technology - Murfreesboro",
      "poi_type": "Education",
      "poi_address": "1303 Old Fort Pkwy #3311, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-a9ca-75be-91a9-19525a325676.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-a9ca-75be-91a9-19525a325676",
        "storage_key": "property/5757210235764736/019f14ff-a9ca-75be-91a9-19525a325676.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://tcatmurfreesboro.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14808210151119267063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tennessee-college-of-applied-technology---murfreesboro",
      "poi_latitude": "35.8456373",
      "poi_longitude": "-86.4100622",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-898-8010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9xVb9Bn4Y4gR9yTM2KxUgc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_dee494a99413555ed3093050",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Middle Tennessee Christian School",
      "poi_type": "Education",
      "poi_address": "100 E MTCS Rd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-a55e-738a-9ebc-0bc362833345.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-a55e-738a-9ebc-0bc362833345",
        "storage_key": "property/5757210235764736/019f14ff-a55e-738a-9ebc-0bc362833345.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mtcscougars.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10310611679815471323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-tennessee-christian-school",
      "poi_latitude": "35.8692068",
      "poi_longitude": "-86.38395009999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-893-0601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTatDzN-cJhUR2xBl4LGmFo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_14b3efc29ae745b63e4811ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Primrose School of North Murfreesboro",
      "poi_type": "Education",
      "poi_address": "2308 Wendelwood Dr, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-a5dd-754a-acfa-62584b124166.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-a5dd-754a-acfa-62584b124166",
        "storage_key": "property/5757210235764736/019f14ff-a5dd-754a-acfa-62584b124166.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.primroseschools.com/schools/north-murfreesboro/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=11478126034877675817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-north-murfreesboro",
      "poi_latitude": "35.8867087",
      "poi_longitude": "-86.3862589",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-802-5592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQf0D4loHZIgRKfkLpNB-Sp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_49c91dfcb530f81310a4fa1a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Learning Zone at Siegel Road",
      "poi_type": "Education",
      "poi_address": "3315 Siegel Rd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-a7d7-70bf-8bb1-84b8ba8b15bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-a7d7-70bf-8bb1-84b8ba8b15bc",
        "storage_key": "property/5757210235764736/019f14ff-a7d7-70bf-8bb1-84b8ba8b15bc.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "https://learningzonechildcare.com/location/learning-zone-siegel/?utm_source=google&utm_medium=organic&utm_campaign=gbp&utm_content=website_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=9384417292614149505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "learning-zone-at-siegel-road",
      "poi_latitude": "35.9100506",
      "poi_longitude": "-86.40286460000002",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-909-2524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ836oGjQGZIgRgaVMjs4lPII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_59bf008f62fb60141b6fcf3f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Jaymes Academy",
      "poi_type": "Education",
      "poi_address": "322 E Clark Blvd, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Daycare with warm staff, kids' crafts and a curriculum to get little ones off to a strong start.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jaymesacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10347568763306540958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jaymes-academy",
      "poi_latitude": "35.8609467",
      "poi_longitude": "-86.383935",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-410-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlxfg0g34Y4gRnn_QaffymY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_f2ef68404e6d8cc48be78b46",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "La Petite Academy of Murfreesboro",
      "poi_type": "Education",
      "poi_address": "342 W Northfield Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Day care center with a STEM curriculum for infants, toddlers, and preschoolers, plus summer camp.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-b6f4-77cb-bf25-5596bdd272c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-b6f4-77cb-bf25-5596bdd272c3",
        "storage_key": "property/5757210235764736/019f14ff-b6f4-77cb-bf25-5596bdd272c3.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/murfreesboro-tn-7457/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7457",
      "poi_directions_map_url": "https://maps.google.com/?cid=2817207821963869487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-of-murfreesboro",
      "poi_latitude": "35.8714012",
      "poi_longitude": "-86.3902013",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX8T3z48HZIgRL72bfpa7GCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_65696002046c33172c462e39",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Cannonsburgh Village",
      "poi_type": "Entertainment",
      "poi_address": "312 S Front St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Reproduction pioneer village featuring a gristmill, a school house, a general store & more.",
      "poi_long_description": "Reproduction pioneer village featuring a gristmill, a school house, a general store & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-ba2d-761d-beb8-556b577075fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-ba2d-761d-beb8-556b577075fd",
        "storage_key": "property/5757210235764736/019f14ff-ba2d-761d-beb8-556b577075fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.murfreesborotn.gov/164/Cannonsburgh-Village",
      "poi_directions_map_url": "https://maps.google.com/?cid=4297667892875141264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cannonsburgh-village",
      "poi_latitude": "35.8438439",
      "poi_longitude": "-86.3961824",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-890-0355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64e8-7498-9592-934832068417",
        "storage_key": "property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVF-ZWv4Y4gRkKBstS1ipDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_720f0d1780f8f417ec7202f9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Discovery Center at Murfree Spring",
      "poi_type": "Entertainment",
      "poi_address": "502 SE Broad St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Interactive kids' museum with exhibits on science & culture plus live animals & outdoor programs.",
      "poi_long_description": "Interactive kids' museum with exhibits on science & culture plus live animals & outdoor programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-28bb-7195-97e7-2f80f2f58376.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-28bb-7195-97e7-2f80f2f58376",
        "storage_key": "property/5757210235764736/019f14fd-28bb-7195-97e7-2f80f2f58376.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://explorethedc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15619293887475863846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-center-at-murfree-spring",
      "poi_latitude": "35.8387545",
      "poi_longitude": "-86.3870876",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-890-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64e8-7498-9592-934832068417",
        "storage_key": "property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxvj-Wf4Y4gRJtFtPQnhwtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_263448dcd8988faa04e8df39",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Stones River National Battlefield Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "Visitor Center, 3501 Old Nashville Hwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Visitor center with a museum, gift shop, and trails through the site of a Civil War battle.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-bc08-7548-86ab-f007cc27c0dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-bc08-7548-86ab-f007cc27c0dd",
        "storage_key": "property/5757210235764736/019f14ff-bc08-7548-86ab-f007cc27c0dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nps.gov/stri/planyourvisit/visitorcenters.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=4148724765557185752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stones-river-national-battlefield-visitor-center",
      "poi_latitude": "35.8805549",
      "poi_longitude": "-86.4347595",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-893-9501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1UQbBQIZIgR2NzmgTE7kzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "ec_620705965c6149336916a705",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Oaklands Mansion",
      "poi_type": "Entertainment",
      "poi_address": "900 N Maney Ave, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Once home to both Confederate & Union soldiers, this plantation now offers tours & activities.",
      "poi_long_description": "Once home to both Confederate & Union soldiers, this plantation now offers tours & activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-b562-769e-84f4-770ff37f10ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-b562-769e-84f4-770ff37f10ec",
        "storage_key": "property/5757210235764736/019f14ff-b562-769e-84f4-770ff37f10ec.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.oaklandsmansion.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14783141961739895160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oaklands-mansion",
      "poi_latitude": "35.856013",
      "poi_longitude": "-86.3850431",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-893-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64e8-7498-9592-934832068417",
        "storage_key": "property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJz9O2ZHn4Y4gReIGtLUpFKM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_c756b21104eea9ff46898ac4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Earth Experience - Middle Tennessee Museum of Natural History",
      "poi_type": "Entertainment",
      "poi_address": "816 Old Salem Rd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Hands-on natural history museum displaying international & local archeological finds & fossils.",
      "poi_long_description": "Hands-on natural history museum displaying international & local archeological finds & fossils.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-b069-7538-8bfd-adf08eb46bc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-b069-7538-8bfd-adf08eb46bc4",
        "storage_key": "property/5757210235764736/019f14ff-b069-7538-8bfd-adf08eb46bc4.webp",
        "width": 1280,
        "height": 717
      },
      "poi_business_url": "http://www.earthexperience.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1439522919434489258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earth-experience---middle-tennessee-museum-of-natural-history",
      "poi_latitude": "35.8368068",
      "poi_longitude": "-86.4025003",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-900-8358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64e8-7498-9592-934832068417",
        "storage_key": "property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIQ-1iz74Y4gRqg3t4nc2-hM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_3105f331e6630449262cf573",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "1952 Old Fort Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-27f5-76ae-b45a-4af364cdaafd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-27f5-76ae-b45a-4af364cdaafd",
        "storage_key": "property/5757210235764736/019f14fd-27f5-76ae-b45a-4af364cdaafd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/tennessee-murfreesboro/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2390275433629450666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.8486667",
      "poi_longitude": "-86.4246622",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-410-9619",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4UUtHn3Y4gRqoHTuNf2KyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "ec_c7419ffbe913f2ee7ef6268b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "GO USA Fun Park",
      "poi_type": "Entertainment",
      "poi_address": "2270 Armory Dr, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Amusement park with go karts, batting cages & arcades, plus mini golf with castle & water features.",
      "poi_long_description": "Amusement park with go karts, batting cages & arcades, plus mini golf with castle & water features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-ba37-7470-bd54-3fa38271c84a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-ba37-7470-bd54-3fa38271c84a",
        "storage_key": "property/5757210235764736/019f14ff-ba37-7470-bd54-3fa38271c84a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.gousafunpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2245445991859610946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "go-usa-fun-park",
      "poi_latitude": "35.8505827",
      "poi_longitude": "-86.43399099999999",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-895-7888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZvo_-X3Y4gRQuUdkzttKR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_eea4bfd1a74d6c69014629e7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Bradley Academy Museum and Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "415 S Academy St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Museum & cultural center in a 1918 school with a Civil War exhibit, theater & an original classroom.",
      "poi_long_description": "Museum & cultural center in a 1918 school with a Civil War exhibit, theater & an original classroom.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-c3f9-74b8-a19f-82d9589fdc5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-c3f9-74b8-a19f-82d9589fdc5e",
        "storage_key": "property/5757210235764736/019f14ff-c3f9-74b8-a19f-82d9589fdc5e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.murfreesborotn.gov/874/Bradley-Academy-Museum-and-Cultural-Cent",
      "poi_directions_map_url": "https://maps.google.com/?cid=12117398181900660700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bradley-academy-museum-and-cultural-center",
      "poi_latitude": "35.8422108",
      "poi_longitude": "-86.38909249999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-962-8773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64e8-7498-9592-934832068417",
        "storage_key": "property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq49siGj4Y4gR3C8nGnKlKag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_7ddca24b9dd0949c66aada2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Center For the Arts",
      "poi_type": "Entertainment",
      "poi_address": "110 W College St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Community venue & art gallery hosting exhibits, music, dance & theatrical events in a 1909 building.",
      "poi_long_description": "Community venue & art gallery hosting exhibits, music, dance & theatrical events in a 1909 building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-be14-70a9-abbf-e4736f24cb90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-be14-70a9-abbf-e4736f24cb90",
        "storage_key": "property/5757210235764736/019f14ff-be14-70a9-abbf-e4736f24cb90.webp",
        "width": 700,
        "height": 400
      },
      "poi_business_url": "http://www.boroarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1344868861526606933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-for-the-arts",
      "poi_latitude": "35.8471707",
      "poi_longitude": "-86.3915808",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-904-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzRR9274Y4gRVQTHqBrvqRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_1ec27530e9cdfe620c55e158",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "AMC Stones River 9",
      "poi_type": "Entertainment",
      "poi_address": "1706 Old Fort Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Multiscreen mall cinema screening current films in theaters with reserved, reclining seats.",
      "poi_long_description": "Multiscreen mall cinema screening current films in theaters with reserved, reclining seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-c63d-70ea-8cd3-0a543645c539.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-c63d-70ea-8cd3-0a543645c539",
        "storage_key": "property/5757210235764736/019f14ff-c63d-70ea-8cd3-0a543645c539.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/nashville-tn/amc-stones-river-9?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10323392328234355477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-stones-river-9",
      "poi_latitude": "35.8479512",
      "poi_longitude": "-86.4179437",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-900-2499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a0f-7113-a066-850b3ff3e128.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a0f-7113-a066-850b3ff3e128",
        "storage_key": "property/5757210235764736/019f1500-2a0f-7113-a066-850b3ff3e128.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJnzso0qf5Y4gRFctmeaAORI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_1b4660c39742fe31381acbb9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Ascension Saint Thomas Rutherford",
      "poi_type": "Health and Wellness",
      "poi_address": "1700 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-3b81-776c-bc49-0b6563c1b650.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-3b81-776c-bc49-0b6563c1b650",
        "storage_key": "property/5757210235764736/019f14fd-3b81-776c-bc49-0b6563c1b650.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/tennessee/tnnas/murfreesboro-ascension-saint-thomas-rutherford?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1168771784860846153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-saint-thomas-rutherford",
      "poi_latitude": "35.8609519",
      "poi_longitude": "-86.4248844",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-396-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-647c-741f-92f8-20b45325da03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-647c-741f-92f8-20b45325da03",
        "storage_key": "property/5757210235764736/019f14fd-647c-741f-92f8-20b45325da03.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRorwbrHxokRSUgh9L5POBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_7aac155cf659d2cb542805e1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Ascension Saint Thomas Urgent Care - Murfreesboro",
      "poi_type": "Health and Wellness",
      "poi_address": "2445 Memorial Blvd C, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-c282-773a-959a-a4a411d73dd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-c282-773a-959a-a4a411d73dd1",
        "storage_key": "property/5757210235764736/019f14ff-c282-773a-959a-a4a411d73dd1.webp",
        "width": 395,
        "height": 408
      },
      "poi_business_url": "https://www.urgentteam.com/locations/ascension-saint-thomas-murfreesboro-memorial-blvd-tn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285678180462412585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-saint-thomas-urgent-care---murfreesboro",
      "poi_latitude": "35.8882492",
      "poi_longitude": "-86.3828856",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-217-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg516rKYHZIgRKcMCyp3sQMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_814d4bd5bbccf2dd07470ded",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Murfreesboro",
      "poi_type": "Health and Wellness",
      "poi_address": "2105 Memorial Blvd Ste B, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-c2dd-760b-aaee-b69696107c2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-c2dd-760b-aaee-b69696107c2e",
        "storage_key": "property/5757210235764736/019f14ff-c2dd-760b-aaee-b69696107c2e.webp",
        "width": 711,
        "height": 400
      },
      "poi_business_url": "https://www.carenow.com/locations/nashville/murfreesboro?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12864383250554208845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---murfreesboro",
      "poi_latitude": "35.8805847",
      "poi_longitude": "-86.3844833",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 615-410-4099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9WqWyPkHZIgRTcLEb2h4h7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_e99e4a44def98f99dba1a09e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "UrgiKids Pediatric Urgent Care (formerly PM Pediatric Care)",
      "poi_type": "Health and Wellness",
      "poi_address": "2249 Medical Center Pkwy Ste C & D, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-c33f-70af-b3c3-0aaf6abdf8f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-c33f-70af-b3c3-0aaf6abdf8f8",
        "storage_key": "property/5757210235764736/019f14ff-c33f-70af-b3c3-0aaf6abdf8f8.webp",
        "width": 780,
        "height": 780
      },
      "poi_business_url": "https://www.urgikids.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3873198194603556973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "urgikids-pediatric-urgent-care-formerly-pm-pediatric-care",
      "poi_latitude": "35.8573493",
      "poi_longitude": "-86.4364547",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 629-219-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlx79syD3Y4gRbYAHpjxdwDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_faacb79578fcdfdac85bd474",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3389 Memorial Blvd Walgreens, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-c89e-75de-a8b8-c5091d0fb0ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-c89e-75de-a8b8-c5091d0fb0ad",
        "storage_key": "property/5757210235764736/019f14ff-c89e-75de-a8b8-c5091d0fb0ad.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3389+memorial+blvd-murfreesboro-tn-37129/id=6693",
      "poi_directions_map_url": "https://maps.google.com/?cid=16480951777246194249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "35.9101692",
      "poi_longitude": "-86.3842493",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 615-867-6720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a08-7190-afe1-b9a878c9e1f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a08-7190-afe1-b9a878c9e1f8",
        "storage_key": "property/5757210235764736/019f1500-2a08-7190-afe1-b9a878c9e1f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa1SCX1EGZIgRSSoaU1IauOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_437ad8c7b7eccd737be0eae5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2012 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-c77d-7119-abb2-e92cb2743d92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-c77d-7119-abb2-e92cb2743d92",
        "storage_key": "property/5757210235764736/019f14ff-c77d-7119-abb2-e92cb2743d92.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/2757-murfreesboro-tn/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17048651764876056241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "35.8790865",
      "poi_longitude": "-86.383153",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 615-995-7097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a08-7190-afe1-b9a878c9e1f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a08-7190-afe1-b9a878c9e1f8",
        "storage_key": "property/5757210235764736/019f1500-2a08-7190-afe1-b9a878c9e1f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_M935sHZIgRsRbG2HP6mOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_df7afd6d2aacad4c18882a2b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1331 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-9771-7409-a1ff-621ad7ba3016.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-9771-7409-a1ff-621ad7ba3016",
        "storage_key": "property/5757210235764736/019f14ff-9771-7409-a1ff-621ad7ba3016.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/murfreesboro-tn-pharmacies/1331-memorial-blvd-murfreesboro-tn-37129/storeid=6420?WT.mc_id=LS_GOOGLE_RX_6420",
      "poi_directions_map_url": "https://maps.google.com/?cid=598746042423419551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "35.8612744",
      "poi_longitude": "-86.3909621",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-893-8887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a08-7190-afe1-b9a878c9e1f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a08-7190-afe1-b9a878c9e1f8",
        "storage_key": "property/5757210235764736/019f1500-2a08-7190-afe1-b9a878c9e1f8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlzpu1YkHZIgRn6JRcVosTwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_70283ac41f769f924958fcd1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "3266 Memorial Blvd Ste D, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-d0d6-75fd-852c-2b5c974b5b9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-d0d6-75fd-852c-2b5c974b5b9b",
        "storage_key": "property/5757210235764736/019f14ff-d0d6-75fd-852c-2b5c974b5b9b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clubpilates.com/murfreesboro/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14944640978331424962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "35.9054301",
      "poi_longitude": "-86.38309799999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 615-691-4699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuTDv91cHZIgRwtgwKcoHZs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_31839e04714aad3b2c01d0f3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2615 Medical Center Pkwy #1730, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Fitness center, chain and studio providing heart rate-based training, plus cardio, strength training and a treadmill.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-dffa-77f1-99c8-c1ba3a152f2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-dffa-77f1-99c8-c1ba3a152f2b",
        "storage_key": "property/5757210235764736/019f14ff-dffa-77f1-99c8-c1ba3a152f2b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/murfreesboro-tennessee-0155?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=7005133219268137974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "35.8574647",
      "poi_longitude": "-86.4430258",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-546-0255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcCYoN73Y4gR9hPEUow7N2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_b6c2f26954c9c45503cf5a04",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Climb Murfreesboro",
      "poi_type": "Health and Wellness",
      "poi_address": "1660 Memorial Blvd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Indoor rock-climbing facility with walls for bouldering and climbing, plus yoga and fitness classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-d7e0-7488-8733-8c560adebae6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-d7e0-7488-8733-8c560adebae6",
        "storage_key": "property/5757210235764736/019f14ff-d7e0-7488-8733-8c560adebae6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://theclimbgyms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14474999615603919044&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "climb-murfreesboro",
      "poi_latitude": "35.8660734",
      "poi_longitude": "-86.38692069999999",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-280-8460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_wv9c4YHZIgRxMj8Y3WH4cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_88531cab4087c464875d84c6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "McKnight Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "120 Dejarnette Ln, Murfreesboro, TN 37130, USA",
      "poi_short_description": "Neighborhood park on 81 acres with a sheltered picnic area, multipurpose fields & a playground.",
      "poi_long_description": "Neighborhood park on 81 acres with a sheltered picnic area, multipurpose fields & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-52e7-714e-879e-e311d93ff3c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-52e7-714e-879e-e311d93ff3c8",
        "storage_key": "property/5757210235764736/019f14fd-52e7-714e-879e-e311d93ff3c8.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "http://www.murfreesborotn.gov/index.aspx?NID=189",
      "poi_directions_map_url": "https://maps.google.com/?cid=5490901918372730309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcknight-park",
      "poi_latitude": "35.8867319",
      "poi_longitude": "-86.38093429999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 615-890-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6484-75ad-bea0-f5a07ca53d10",
        "storage_key": "property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJT-pt3aYHZIgRxRUe5TOaM0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b9734f2676a63f5d95c2d4d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Old Fort Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1025 Old Fort Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-e0e0-749f-836d-f185d07d2e92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-e0e0-749f-836d-f185d07d2e92",
        "storage_key": "property/5757210235764736/019f14ff-e0e0-749f-836d-f185d07d2e92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.murfreesborotn.gov/190/Old-Fort-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7083635626778081809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-fort-park",
      "poi_latitude": "35.8469394",
      "poi_longitude": "-86.4076836",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6484-75ad-bea0-f5a07ca53d10",
        "storage_key": "property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnTNXDgD5Y4gREbpoZBIhTmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_5d94c96fc2b52774dbf7b754",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Overall Street Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "264-266 Overall St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Trail leading to a creek, plus a picnic area and river views in a relaxing setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-e912-7788-b0c6-d1ac0c9e91a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-e912-7788-b0c6-d1ac0c9e91a8",
        "storage_key": "property/5757210235764736/019f14ff-e912-7788-b0c6-d1ac0c9e91a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.murfreesborotn.gov/Facilities/Facility/Details/8",
      "poi_directions_map_url": "https://maps.google.com/?cid=8841271733265295593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overall-street-trailhead",
      "poi_latitude": "35.8502202",
      "poi_longitude": "-86.4069695",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-890-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-qRJBD4Y4gR6ej6X8yBsno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_a432100b8604abcad3b56814",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Fortress Rosecrans",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1012 Golf Ln, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Historic remnants of an 1863 earthworks fort, the largest one built during the Civil War.",
      "poi_long_description": "Historic remnants of an 1863 earthworks fort, the largest one built during the Civil War.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-f083-708c-99b8-e1806b34b271.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-f083-708c-99b8-e1806b34b271",
        "storage_key": "property/5757210235764736/019f14ff-f083-708c-99b8-e1806b34b271.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nps.gov/stri/learn/historyculture/foro.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=14518186796516162666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fortress-rosecrans",
      "poi_latitude": "35.8522943",
      "poi_longitude": "-86.41188939999999",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-893-9501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2AX3QT4Y4gRarwchfj1esk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "ec_0942eb6e89d4180c6272867b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Stones River National Battlefield Visitor Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Visitor Center, 3501 Old Nashville Hwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Visitor center with a museum, gift shop, and trails through the site of a Civil War battle.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-bc08-7548-86ab-f007cc27c0dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-bc08-7548-86ab-f007cc27c0dd",
        "storage_key": "property/5757210235764736/019f14ff-bc08-7548-86ab-f007cc27c0dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nps.gov/stri/planyourvisit/visitorcenters.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=4148724765557185752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stones-river-national-battlefield-visitor-center",
      "poi_latitude": "35.8805549",
      "poi_longitude": "-86.4347595",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-893-9501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1UQbBQIZIgR2NzmgTE7kzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "ec_0084f64b95061eb6ade9d0aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Cannonsburgh Village",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "312 S Front St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Reproduction pioneer village featuring a gristmill, a school house, a general store & more.",
      "poi_long_description": "Reproduction pioneer village featuring a gristmill, a school house, a general store & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-ba2d-761d-beb8-556b577075fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-ba2d-761d-beb8-556b577075fd",
        "storage_key": "property/5757210235764736/019f14ff-ba2d-761d-beb8-556b577075fd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.murfreesborotn.gov/164/Cannonsburgh-Village",
      "poi_directions_map_url": "https://maps.google.com/?cid=4297667892875141264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cannonsburgh-village",
      "poi_latitude": "35.8438439",
      "poi_longitude": "-86.3961824",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-890-0355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-64e8-7498-9592-934832068417",
        "storage_key": "property/5757210235764736/019f14fd-64e8-7498-9592-934832068417.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVF-ZWv4Y4gRkKBstS1ipDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_81abf14bf63f2d6121431335",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Gateway Island",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1875 W College St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Reception center with a kitchen & meeting rooms, plus picnic areas, a lake overlook & asphalt trail.",
      "poi_long_description": "Reception center with a kitchen & meeting rooms, plus picnic areas, a lake overlook & asphalt trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-eaf5-74be-9ed8-63e34f1be687.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-eaf5-74be-9ed8-63e34f1be687",
        "storage_key": "property/5757210235764736/019f14ff-eaf5-74be-9ed8-63e34f1be687.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.murfreesborotn.gov/184/Gateway-Island",
      "poi_directions_map_url": "https://maps.google.com/?cid=2844866400805143930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gateway-island",
      "poi_latitude": "35.8642187",
      "poi_longitude": "-86.419353",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-890-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6484-75ad-bea0-f5a07ca53d10",
        "storage_key": "property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJib16YwAIZIgRekVvNev-eic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_391c5a6b7dbd6f9ca873b7fc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Broad Street Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1921 NW Broad St, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-f7d9-72de-8e67-e55428a36e24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-f7d9-72de-8e67-e55428a36e24",
        "storage_key": "property/5757210235764736/019f14ff-f7d9-72de-8e67-e55428a36e24.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.murfreesborotn.gov/index.aspx?NID=185",
      "poi_directions_map_url": "https://maps.google.com/?cid=13617409743876391325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broad-street-trailhead",
      "poi_latitude": "35.8750303",
      "poi_longitude": "-86.4233514",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 615-890-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfQwzggIZIgRnQGykAPC-rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_54782ac061afacfacbe5e1c2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Cason Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1100 Cason Trail, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Scenic park on local trail network with pavilions, a playground & restroom facilities.",
      "poi_long_description": "Scenic park on local trail network with pavilions, a playground & restroom facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-47e9-76ce-a645-08afaed85c5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-47e9-76ce-a645-08afaed85c5e",
        "storage_key": "property/5757210235764736/019f14fd-47e9-76ce-a645-08afaed85c5e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.murfreesborotn.gov/facilities/facility/details/Cason-Trailhead-10",
      "poi_directions_map_url": "https://maps.google.com/?cid=10694079305443548393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cason-trailhead",
      "poi_latitude": "35.8257189",
      "poi_longitude": "-86.424449",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 615-890-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6484-75ad-bea0-f5a07ca53d10",
        "storage_key": "property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5mxPIT3Y4gR6ZzR-HcAaZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_35c0d3db13995b28e006a451",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Barfield Crescent Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "697 Veterans Pkwy, Murfreesboro, TN 37128, USA",
      "poi_short_description": "Leafy community park with hiking trails, sports fields, a golf course & campsites over 430 acres.",
      "poi_long_description": "Leafy community park with hiking trails, sports fields, a golf course & campsites over 430 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-064a-71f9-8f0a-45bb3c9fe85b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-064a-71f9-8f0a-45bb3c9fe85b",
        "storage_key": "property/5757210235764736/019f1500-064a-71f9-8f0a-45bb3c9fe85b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.murfreesborotn.gov/181/Barfield-Crescent-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7820963255541423215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barfield-crescent-park",
      "poi_latitude": "35.78400420000001",
      "poi_longitude": "-86.4139969",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 615-890-5333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6484-75ad-bea0-f5a07ca53d10",
        "storage_key": "property/5757210235764736/019f14fd-6484-75ad-bea0-f5a07ca53d10.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWLqJ-P5Y4gRb9ztx6SkiWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1f628fac76f872ef7f5e439a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Murfreesboro Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "324 New Salem Hwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8845098556559688270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "murfreesboro-transit-center",
      "poi_latitude": "35.8415655",
      "poi_longitude": "-86.4092474",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmY1acQD5Y4gRToIPG0YawHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_5a8c681acb562d8e3e2490bf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "City of Murfreesboro Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1930 Memorial Blvd, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-50eb-7172-86e7-277e55d5e083.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-50eb-7172-86e7-277e55d5e083",
        "storage_key": "property/5757210235764736/019f14fd-50eb-7172-86e7-277e55d5e083.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.murfreesborotn.gov/95/Airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=7109091869414085853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-murfreesboro-airport",
      "poi_latitude": "35.876983",
      "poi_longitude": "-86.3807137",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-848-3254",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6d82-739e-a3c9-0f9ba4faee75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6d82-739e-a3c9-0f9ba4faee75",
        "storage_key": "property/5757210235764736/019f14fd-6d82-739e-a3c9-0f9ba4faee75.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ850w35sHZIgR3VQLwGORqGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_848a35551fb111ac174fa14d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Stones River Town Centre",
      "poi_type": "Transportation & Transit",
      "poi_address": "1720 Old Fort Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Indoor site with fashion & accessory chains, personal care, dining, kids' activities & movies.",
      "poi_long_description": "Indoor site with fashion & accessory chains, personal care, dining, kids' activities & movies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-a04c-7211-bd02-833ce212ce85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-a04c-7211-bd02-833ce212ce85",
        "storage_key": "property/5757210235764736/019f14ff-a04c-7211-bd02-833ce212ce85.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.shopstonesriver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=106645893605734169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stones-river-town-centre",
      "poi_latitude": "35.8480189",
      "poi_longitude": "-86.4175283",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-896-4486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6422-7678-9375-0722122d1a41",
        "storage_key": "property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9_Wm1ff3Y4gRGbcfDeDhegE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_6ea0414ae6affc23348b261d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 W Main St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-001e-70d2-b321-9c93a869ec6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-001e-70d2-b321-9c93a869ec6f",
        "storage_key": "property/5757210235764736/019f1500-001e-70d2-b321-9c93a869ec6f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/en-us/bus-station-400609",
      "poi_directions_map_url": "https://maps.google.com/?cid=14278922801362826142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "35.8469066",
      "poi_longitude": "-86.3991106",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-78ORP4Y4gRnvN0hqLsKMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_4a5725c35c80d98c080fa420",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Nashville International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Terminal Dr, Nashville, TN 37214, USA",
      "poi_short_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_long_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-018d-707a-9ec9-2a9e84163161.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-018d-707a-9ec9-2a9e84163161",
        "storage_key": "property/5757210235764736/019f1500-018d-707a-9ec9-2a9e84163161.webp",
        "width": 1280,
        "height": 754
      },
      "poi_business_url": "https://flynashville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12319467440219005563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nashville-international-airport",
      "poi_latitude": "36.1248851",
      "poi_longitude": "-86.6762176",
      "poi_miles_from_property": "24.8 mi",
      "poi_walking_minutes": "9 hours 5 mins",
      "poi_biking_minutes": "2 hours 24 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 615-275-1675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6d82-739e-a3c9-0f9ba4faee75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6d82-739e-a3c9-0f9ba4faee75",
        "storage_key": "property/5757210235764736/019f14fd-6d82-739e-a3c9-0f9ba4faee75.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJWT0fVKtuZIgRe6I-lF2K96o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_b981d293e4e90d06187c554e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "CareNow Urgent Care - Murfreesboro Medical Center Parkway",
      "poi_type": "Transportation & Transit",
      "poi_address": "3031 Medical Center Pkwy Ste B, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14ff-fd02-775e-ae06-fed8ed198c3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14ff-fd02-775e-ae06-fed8ed198c3d",
        "storage_key": "property/5757210235764736/019f14ff-fd02-775e-ae06-fed8ed198c3d.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.carenow.com/locations/nashville/medical-center-murfreesboro?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5033171971028789283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---murfreesboro-medical-center-parkway",
      "poi_latitude": "35.8661131",
      "poi_longitude": "-86.4503143",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 615-846-8585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_gE2SsIZIgRI6ifoj1r2UU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_a9ba1454b57f4872e2ab3d93",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Groome Transportation",
      "poi_type": "Transportation & Transit",
      "poi_address": "5712 Ringgold Rd, East Ridge, TN 37412, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-07e0-72cd-bb09-e67a048b162a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-07e0-72cd-bb09-e67a048b162a",
        "storage_key": "property/5757210235764736/019f1500-07e0-72cd-bb09-e67a048b162a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://groometransportation.com/chattanooga/?utm_source=google&utm_medium=organic&utm_campaign=gbp_chattanooga",
      "poi_directions_map_url": "https://maps.google.com/?cid=9410656605956952660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "groome-transportation",
      "poi_latitude": "34.9907906",
      "poi_longitude": "-85.2238447",
      "poi_miles_from_property": "116 mi",
      "poi_walking_minutes": "1 day 18 hours",
      "poi_biking_minutes": "12 hours 48 mins",
      "poi_driving_minutes": "1 hour 54 mins",
      "poi_business_phone": "+1 423-954-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPdE57vhmYIgRVFI_xVJemYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport_shuttle_service"
    },
    {
      "id": "ec_0bbc3d026f523eeea268b023",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Parking Services Building",
      "poi_type": "Transportation & Transit",
      "poi_address": "205 City View Dr, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-1019-75b0-ada9-41b7ee8f23d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-1019-75b0-ada9-41b7ee8f23d3",
        "storage_key": "property/5757210235764736/019f1500-1019-75b0-ada9-41b7ee8f23d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17807545696386890525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parking-services-building",
      "poi_latitude": "35.8427171",
      "poi_longitude": "-86.3554431",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-2a3d-70d4-9275-1ab0468f4f33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f1500-2a3d-70d4-9275-1ab0468f4f33",
        "storage_key": "property/5757210235764736/019f1500-2a3d-70d4-9275-1ab0468f4f33.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJK61hGcP5Y4gRHTutYnYcIfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "ec_766b0f594f68616c6f05dcb6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "The Avenue Murfreesboro",
      "poi_type": "Transportation & Transit",
      "poi_address": "2615 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "Large outdoor shopping center with landscaped walkways, ample parking & varied restaurants.",
      "poi_long_description": "Large outdoor shopping center with landscaped walkways, ample parking & varied restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-11aa-7475-9bc9-1893a23b7b2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-11aa-7475-9bc9-1893a23b7b2b",
        "storage_key": "property/5757210235764736/019f14fd-11aa-7475-9bc9-1893a23b7b2b.webp",
        "width": 1024,
        "height": 680
      },
      "poi_business_url": "https://theavenuemurfreesboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4544059927879211805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-avenue-murfreesboro",
      "poi_latitude": "35.8584298",
      "poi_longitude": "-86.44513959999999",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-893-4207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6422-7678-9375-0722122d1a41",
        "storage_key": "property/5757210235764736/019f14fd-6422-7678-9375-0722122d1a41.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOeRiMNn3Y4gRHdtTz22-Dz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_c4ffe7be5ab41a2a6f97f43d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Ascension Saint Thomas Rutherford",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 Medical Center Pkwy, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-3b81-776c-bc49-0b6563c1b650.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-3b81-776c-bc49-0b6563c1b650",
        "storage_key": "property/5757210235764736/019f14fd-3b81-776c-bc49-0b6563c1b650.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/tennessee/tnnas/murfreesboro-ascension-saint-thomas-rutherford?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1168771784860846153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-saint-thomas-rutherford",
      "poi_latitude": "35.8609519",
      "poi_longitude": "-86.4248844",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-396-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-647c-741f-92f8-20b45325da03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-647c-741f-92f8-20b45325da03",
        "storage_key": "property/5757210235764736/019f14fd-647c-741f-92f8-20b45325da03.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCRorwbrHxokRSUgh9L5POBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_fce716b8695da701447dbb55",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Middle Tennessee State University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1301 E Main St, Murfreesboro, TN 37132, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-1e3a-75ca-be8b-eb6b2b4a9bdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-1e3a-75ca-be8b-eb6b2b4a9bdc",
        "storage_key": "property/5757210235764736/019f14fd-1e3a-75ca-be8b-eb6b2b4a9bdc.webp",
        "width": 1158,
        "height": 478
      },
      "poi_business_url": "https://www.mtsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12390517612238132658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-tennessee-state-university",
      "poi_latitude": "35.8486229",
      "poi_longitude": "-86.36691549999999",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-898-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpcKjWZf4Y4gRstWs3B7286s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_ef456b579daaa98300c3e924",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Alvin C. York VA Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3400 Lebanon Rd, Murfreesboro, TN 37129, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-47f3-761c-87a8-089dd4fe3a77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-47f3-761c-87a8-089dd4fe3a77",
        "storage_key": "property/5757210235764736/019f14fd-47f3-761c-87a8-089dd4fe3a77.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.va.gov/directory/guide/facility.asp?id=94",
      "poi_directions_map_url": "https://maps.google.com/?cid=17143216071786752291&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alvin-c-york-va-medical-center",
      "poi_latitude": "35.9147379",
      "poi_longitude": "-86.380001",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 615-867-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6418-7286-80e2-a43ee9ab1eec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6418-7286-80e2-a43ee9ab1eec",
        "storage_key": "property/5757210235764736/019f14fd-6418-7286-80e2-a43ee9ab1eec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-e8CjFgGZIgRI-mdSjDw6O0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_573893a627be41712963409f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "BNA3 Amazon Fulfillment Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2020 Joe B Jackson Pkwy, Murfreesboro, TN 37127, USA",
      "poi_short_description": "Chain facility primarily categorized as a warehouse.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-1598-757e-9adf-b7115acabf48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-1598-757e-9adf-b7115acabf48",
        "storage_key": "property/5757210235764736/019f1500-1598-757e-9adf-b7115acabf48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4818390984801170569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bna3-amazon-fulfillment-center",
      "poi_latitude": "35.7777708",
      "poi_longitude": "-86.3635086",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 866-216-1072",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQvCOXj5Y4gRibQEXhJd3kI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_cffd5f66e9dc88140973cbc5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Rutherford County Board of Education",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2240 Southpark Dr, Murfreesboro, TN 37128, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.rcschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8907406498491847688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutherford-county-board-of-education",
      "poi_latitude": "35.8131942",
      "poi_longitude": "-86.4021604",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 615-893-5812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6483-7719-8ba3-7fdfe6f5e776",
        "storage_key": "property/5757210235764736/019f14fd-6483-7719-8ba3-7fdfe6f5e776.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmSkuWMn5Y4gRCNScVAR3nXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_42ebebd9e3ae235e879321bc",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "City of Murfreesboro - City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 W Vine St, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-4d6c-75ee-8954-8a4ddc63991b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fd-4d6c-75ee-8954-8a4ddc63991b",
        "storage_key": "property/5757210235764736/019f14fd-4d6c-75ee-8954-8a4ddc63991b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.murfreesborotn.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11339899403198497773&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-murfreesboro---city-hall",
      "poi_latitude": "35.8441278",
      "poi_longitude": "-86.392957",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-893-5210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6418-7286-80e2-a43ee9ab1eec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6418-7286-80e2-a43ee9ab1eec",
        "storage_key": "property/5757210235764736/019f14fd-6418-7286-80e2-a43ee9ab1eec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwvbWWn4Y4gR7YNPBG1qX50",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_ee3e6d866a843ad5477ac17d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Rutherford County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "S Public Square, Murfreesboro, TN 37130, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-1dc4-7018-b11b-a20dbc7e555a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-1dc4-7018-b11b-a20dbc7e555a",
        "storage_key": "property/5757210235764736/019f1500-1dc4-7018-b11b-a20dbc7e555a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rutherfordcountytn.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18142830710514575470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutherford-county-courthouse",
      "poi_latitude": "35.8460138",
      "poi_longitude": "-86.39201419999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-898-7831",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6418-7286-80e2-a43ee9ab1eec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6418-7286-80e2-a43ee9ab1eec",
        "storage_key": "property/5757210235764736/019f14fd-6418-7286-80e2-a43ee9ab1eec.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQb2jdfUJZIgRbuhECGhIyPs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_46e157ebe7a0ffe3a56b1ae4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Nissan Smyrna Assembly Plant",
      "poi_type": "Major Employers & Offices",
      "poi_address": "983 Nissan Dr, Smyrna, TN 37167, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-13a9-765d-8ab5-baeb01186aca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-13a9-765d-8ab5-baeb01186aca",
        "storage_key": "property/5757210235764736/019f1500-13a9-765d-8ab5-baeb01186aca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://nissan-smyrna.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16631528119583190735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nissan-smyrna-assembly-plant",
      "poi_latitude": "35.9640439",
      "poi_longitude": "-86.4930116",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 615-459-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt3mxQKUOZIgRzy6tB7UOz-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_2ec9bf9791b15b31c6e1d321",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Ingram Content Group LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Ingram Blvd, La Vergne, TN 37086, USA",
      "poi_short_description": "Distribution service and book publisher also acting as a point of interest.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-1266-7569-b868-54ea801768cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-1266-7569-b868-54ea801768cc",
        "storage_key": "property/5757210235764736/019f1500-1266-7569-b868-54ea801768cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ingramcontent.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8322979339321512268&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingram-content-group-llc",
      "poi_latitude": "35.996985",
      "poi_longitude": "-86.5893076",
      "poi_miles_from_property": "16.2 mi",
      "poi_walking_minutes": "5 hours 55 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 615-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE3H5xNdyZIgRTJEssZwpgXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supplier"
    },
    {
      "id": "ec_4366f304a7d7b1c0d535d7e5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "generator",
      "poi_name": "Taylor Farms Tennessee Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "199 Sam Ridley Pkwy E, Smyrna, TN 37167, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f1500-1535-7053-a23a-0847b175ba5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f1500-1535-7053-a23a-0847b175ba5d",
        "storage_key": "property/5757210235764736/019f1500-1535-7053-a23a-0847b175ba5d.webp",
        "width": 1079,
        "height": 606
      },
      "poi_business_url": "http://www.taylorfarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6830729078312266837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taylor-farms-tennessee-inc",
      "poi_latitude": "35.9992646",
      "poi_longitude": "-86.5022823",
      "poi_miles_from_property": "12.1 mi",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 615-984-2797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fd-6474-7234-ad93-4650ded602a6",
        "storage_key": "property/5757210235764736/019f14fd-6474-7234-ad93-4650ded602a6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqfayu9UNZIgRVey77eefy14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    }
  ],
  "office_hours": [
    {
      "id": "custom_eb60efec-8a56-446d-9347-871468803837",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_faa3bcaf-2b1f-4128-9300-f1adc98d091e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_aae3b30b-e807-4fe4-9aad-6805c83077ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_436c84d4-3cb9-43f3-81d1-9e3be5a339ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_92dcc353-7631-432e-8fac-1fed56739fca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b991bb7d-6988-4c99-9d8e-57b1bff59f7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_a5180f19-3f4b-463a-b745-89af835662eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "rating": "5.0",
      "name": "Mia Gardner",
      "text": "Parc is by far the best apartment I have ever lived at!! Staff is phenomenal, property is extremely well maintained, maintenance is always quick and efficient and the amenities are amazing! I haven’t had a single negative experience in the 2 years I have lived here. This apartment genuinely puts in daily effort to make this community a better place than it was the day before. I have never felt so safe, respected, and at home at an apartment before. It’s also so lovely and peaceful here. There is such a warm and welcoming atmosphere. Would highly recommend living here! :)",
      "date": "2026-05-27",
      "title": ""
    },
    {
      "id": "custom_7763355b-e6f1-45e2-bec3-c1b31eab1a8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "rating": "5.0",
      "name": "Matthew Ellis",
      "text": "I love this place!! The staff is friendly and very helpful! The maintenance team is amazing. The areas outside are extremely well maintained. The club house has a pool table which I absolutely love. The apartments are beautiful and comfortable. This is the absolute best apartment experience I’ve ever encountered. Ten out ten that my rating. Great place to live.",
      "date": "2026-05-01",
      "title": ""
    },
    {
      "id": "custom_26be4ee2-3906-4284-bb94-68cf5a1bc45c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "rating": "5.0",
      "name": "upasna paul",
      "text": "I recently moved into The PARC Apartments in Murfreesboro , and my experience has been amazing from the start. The move-in process was smooth and stress-free, thanks to the friendly and professional staff who were incredibly helpful throughout. The community feels very safe and well-maintained, which gives me great peace of mind.\n\nA special shoutout to the maintenance team — they are prompt, efficient, and always ready to help with a smile. It’s rare to find a place where everyone, from the office staff to maintenance, genuinely cares about residents’ comfort and satisfaction.\n\nI’m truly happy to call The PARC my new home! 🌿🏡",
      "date": "2025-10-14",
      "title": ""
    },
    {
      "id": "custom_f69edc34-b593-4eca-874b-c7ba04ed6022",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "rating": "5.0",
      "name": "Cameron Robinson",
      "text": "Parc at Murfreesboro Apartments is such a great place to live. The complex itself is beautiful, clean, and well maintained, and the community has a welcoming, positive vibe.\n\nOn top of that, the LEASING TEAM is amazing! They are super professional, supportive, and always willing to go above and beyond. They’re quick to answer questions (no matter how many I have... LOL) and make sure you have everything you need. You can tell they truly care about their residents.\n\nHIGHLY recommend if you’re looking for great management, a great community, and a great place to call home!",
      "date": "2026-01-10",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6fba3e72-8551-4cb0-a187-1031231369a3",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019d02f4-d287-77d8-95dd-34c14f62798e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious community lounge with comfortable seating, a pool table, and a shuffleboard table.",
        "public_id": "019d02f4-d287-77d8-95dd-34c14f62798e",
        "storage_key": "property/5757210235764736/019d02f4-d287-77d8-95dd-34c14f62798e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Clubhouse",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=SrC61M1N2Dh"
    },
    {
      "id": "custom_4abc9ff8-e442-4d27-b6df-bd9e4e1e0add",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019d02f4-0cb3-7278-887a-979860554aa2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern apartment gym with weight machines, treadmills, and free weights.",
        "public_id": "019d02f4-0cb3-7278-887a-979860554aa2",
        "storage_key": "property/5757210235764736/019d02f4-0cb3-7278-887a-979860554aa2.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=otapwZsCxU2"
    },
    {
      "id": "custom_6d1184ce-bbe9-4584-9bc3-cbebbdec17b4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019d02f4-d287-77d8-95dd-3a8ac8356455.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Outdoor dining area with a long wooden table and chairs overlooking a swimming pool and apartment buildings.",
        "public_id": "019d02f4-d287-77d8-95dd-3a8ac8356455",
        "storage_key": "property/5757210235764736/019d02f4-d287-77d8-95dd-3a8ac8356455.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Outdoor Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4F48Jq5TpUj"
    },
    {
      "id": "custom_836de461-8be5-42bb-9a8a-da1b6ba38a8f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019d02f4-d2cb-73fc-865e-7d1ead6a4988.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern living room with a leather sofa, coffee table, TV, and large windows.",
        "public_id": "019d02f4-d2cb-73fc-865e-7d1ead6a4988",
        "storage_key": "property/5757210235764736/019d02f4-d2cb-73fc-865e-7d1ead6a4988.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Olympic Sunroom - 833SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dfqaXeJD75y"
    },
    {
      "id": "custom_2536a6d9-ec1f-4715-8951-0c56890b5b12",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019d02f4-d4aa-7299-a3f7-6a2629ba703b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV.",
        "public_id": "019d02f4-d4aa-7299-a3f7-6a2629ba703b",
        "storage_key": "property/5757210235764736/019d02f4-d4aa-7299-a3f7-6a2629ba703b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - Shenandoah - 1,209SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5XkrS1257Jq"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-d080-70d1-b6a6-017a2a4c7441",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "parc-at-murfreesboro",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736"
    },
    {
      "lead_collector_id": "0198aa45-d0e4-7305-ba97-fbcfabeabe5c",
      "lead_source": "FACEBOOK_ADS",
      "name": "parc-at-murfreesboro",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736"
    },
    {
      "lead_collector_id": "0198aa45-d147-705a-b635-cd43a6b611d2",
      "lead_source": "LANDING_PAGE",
      "name": "parc-at-murfreesboro",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-laundry-murfreesboro-751",
      "search_query": "apartments with in-unit laundry murfreesboro tn",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Explore top-tier apartments with in-unit laundry in Murfreesboro, TN. Comfort meets convenience with our modern interiors and thoughtful amenities.",
      "page_copy": "Experience the joy of having essential amenities right at home with Parc At Murfreesboro's apartments featuring in-unit laundry. Imagine enjoying the convenience of laundry facilities just steps away from your bedroom. Located in the vibrant neighborhood of Murfreesboro, TN, our community offers more than just a place to live. \n\nOur one, two, and three-bedroom apartment homes are designed to meet all your needs. Besides in-unit laundry, each unit comes with walk-in closets and a modern technology package. Enjoy resort-style living with access to our state-of-the-art fitness center, dog park, and coffee bar. Discover why Parc At Murfreesboro is the ideal choice for a convenient and elevated lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite island, stainless steel dishwasher, and open-concept living area.",
        "public_id": "019f6c10-3fff-72ad-85a9-b8a7e2a69669",
        "storage_key": "property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Available",
      "seo_description": "Find your perfect apartment with in-unit laundry in Murfreesboro, TN at Parc At Murfreesboro. Convenient living with exclusive amenities awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-rutherford-county-321",
      "search_query": "dog-friendly apartments in rutherford county",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Rutherford",
      "h2_subtitle": "Discover dog-friendly apartments in Rutherford County. Enjoy spacious living with pet-friendly amenities at Parc At Murfreesboro.",
      "page_copy": "Welcome to Parc At Murfreesboro, where dog-friendly living is embraced with open arms! Our community is located in the heart of Rutherford County and offers a range of pet-friendly features that cater to you and your furry friends. With a dedicated dog park on-site, your pet can enjoy leisure time and play in a safe environment.\n\nOur spacious one, two, and three-bedroom floor plans are designed with modern comforts in mind, perfect for pet owners. Enjoy community amenities like a fitness center and luxurious coffee bar. Our dog-friendly apartments ensure you and your pet experience an elevated lifestyle in the vibrant Murfreesboro area. Schedule a tour today to see your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite island, stainless steel dishwasher, and open-concept living area.",
        "public_id": "019f6c10-3fff-72ad-85a9-b8a7e2a69669",
        "storage_key": "property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Rutherford",
      "seo_description": "Find dog-friendly apartments in Rutherford County at Parc At Murfreesboro. Enjoy pet-friendly amenities and vibrant living!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "page_item_url": "apartments-with-pools-murfreesboro-328",
      "search_query": "apartments with pools murfreesboro",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in Murfreesboro",
      "h2_subtitle": "Dive into luxury with apartments featuring pools in Murfreesboro. Enjoy resort-style amenities at Parc At Murfreesboro.",
      "page_copy": "Uncover your perfect retreat with our apartments featuring pools at Parc At Murfreesboro. Situated in the energetic city of Murfreesboro, TN, our apartments are designed to offer a lifestyle of comfort and leisure. Imagine spending warm days lounging by our pool or taking a refreshing dip to unwind.\n\nOur community provides more than just beautiful pools. Choose from spacious one, two, and three-bedroom units that come with modern amenities including walk-in closets and a technology package. Beyond the pool, you'll have access to a full suite of facilities like a fitness center and dog park. Live the resort-style life you’ve been dreaming of at Parc At Murfreesboro.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite island, stainless steel dishwasher, and open-concept living area.",
        "public_id": "019f6c10-3fff-72ad-85a9-b8a7e2a69669",
        "storage_key": "property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pools in Murfreesboro",
      "seo_description": "Discover apartments with pools in Murfreesboro at Parc At Murfreesboro. Experience resort-style living with premier amenities!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "page_item_url": "luxury-apartments-fitness-center-37129-141",
      "search_query": "luxury apartments with fitness center 37129",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Experience luxury living with a state-of-the-art fitness center in the 37129 area. Unwind and stay fit at Parc At Murfreesboro.",
      "page_copy": "Discover the perfect blend of luxury and fitness at Parc At Murfreesboro, located in the heart of the 37129 area. Our luxury apartments offer a state-of-the-art fitness center, providing you with everything you need to maintain your active lifestyle without leaving the comfort of your community.\n\nChoose from our spacious one, two, or three-bedroom floor plans, all designed with contemporary elegance and convenience. Alongside an impressive fitness center, residents can enjoy other upscale amenities like a dog park, coffee bar, and modern in-unit technology. Elevate your living experience at Parc At Murfreesboro, where luxury meets wellness.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite island, stainless steel dishwasher, and open-concept living area.",
        "public_id": "019f6c10-3fff-72ad-85a9-b8a7e2a69669",
        "storage_key": "property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments & Fitness Center 37129",
      "seo_description": "Find luxury apartments with a fitness center in the 37129 area at Parc At Murfreesboro. Enjoy upscale living and premium amenities!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "page_item_url": "pet-spa-apartments-murfreesboro-tn-598",
      "search_query": "pet spa apartments murfreesboro tn",
      "category": "Amenity",
      "h1_title": "Pet Spa Apartments in Murfreesboro",
      "h2_subtitle": "Explore pet-friendly apartments with spa amenities in Murfreesboro, TN. Parc At Murfreesboro offers a haven for you and your pet.",
      "page_copy": "Welcome to Parc At Murfreesboro, the epitome of pet-friendly luxury in Murfreesboro, TN! Perfectly catering to you and your pet's needs, our community features apartments equipped with exceptional amenities, including an exclusive pet spa area. Treat your furry friend to a pampering experience and enhance their wellbeing without having to leave home.\n\nIn addition to the pet spa, our stylish one, two, and three-bedroom apartments offer modern features designed for comfort and convenience. Dive into a range of other amenities, such as a fully equipped fitness center and a serene coffee bar. Live the life you've imagined at Parc At Murfreesboro, where both you and your pet can thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite island, stainless steel dishwasher, and open-concept living area.",
        "public_id": "019f6c10-3fff-72ad-85a9-b8a7e2a69669",
        "storage_key": "property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Spa Apartments Murfreesboro, TN",
      "seo_description": "Discover pet spa-equipped apartments in Murfreesboro, TN at Parc At Murfreesboro. Enjoy luxury amenities perfect for you and your pet!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-rutherford-county-tn-116",
      "search_query": "one bedroom apartments Rutherford County TN",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Rutherford County",
      "h2_subtitle": "Explore one bedroom apartments in Rutherford County, TN, at Parc At Murfreesboro. Experience comfort and style in a vibrant community.",
      "page_copy": "Discover your ideal one bedroom apartment at Parc At Murfreesboro, nestled in the vibrant Rutherford County, TN. Our thoughtfully designed apartments offer the perfect blend of modern style and convenience. Bask in the comfort of spacious layouts, complemented by upscale features like walk-in closets and high-quality finishes.\n\nLocated in a community bustling with amenities, our one-bedroom options are perfect for those seeking a balance of privacy and access to recreational features. Enjoy our resort-style pool, a well-equipped fitness center, and more. With easy access to everything Murfreesboro has to offer, make Parc At Murfreesboro your new home base in Rutherford County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite island, stainless steel dishwasher, and open-concept living area.",
        "public_id": "019f6c10-3fff-72ad-85a9-b8a7e2a69669",
        "storage_key": "property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Rutherford County, TN",
      "seo_description": "Find one bedroom apartments in Rutherford County, TN at Parc At Murfreesboro. Enjoy modern amenities and a vibrant lifestyle!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-murfreesboro-tn-357",
      "search_query": "two bedroom apartments Murfreesboro TN",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Murfreesboro",
      "h2_subtitle": "Discover spacious two bedroom apartments in Murfreesboro, TN. Parc At Murfreesboro offers comfortable living with premium amenities.",
      "page_copy": "Experience the perfect blend of modern living and comfort in our two-bedroom apartments at Parc At Murfreesboro, TN. Designed with spaciousness in mind, these apartments offer ample living areas along with contemporary finishes that cater to both functionality and style. Ideal for families, roommates, or those desiring extra space, our two-bedroom layouts provide the flexibility you need.\n\nLocated in the heart of Murfreesboro, TN, our complex boasts an array of amenities, including a rejuvenating fitness center, dog park, and inviting coffee bar. With quick access to local attractions, shopping, and dining, Parc At Murfreesboro is the perfect place to call home. Embrace the lifestyle you deserve today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite island, stainless steel dishwasher, and open-concept living area.",
        "public_id": "019f6c10-3fff-72ad-85a9-b8a7e2a69669",
        "storage_key": "property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Murfreesboro, TN",
      "seo_description": "Find spacious two bedroom apartments in Murfreesboro, TN at Parc At Murfreesboro, complete with modern amenities and convenient location!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757210235764736",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-37129-709",
      "search_query": "three bedroom apartments near 37129",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 37129",
      "h2_subtitle": "Explore three bedroom apartments near 37129 at Parc At Murfreesboro. Our spacious units offer luxury and convenience close to the heart of Murfreesboro, TN.",
      "page_copy": "Imagine living in a spacious three-bedroom apartment exquisitely designed for comfort and convenience. Located near the 37129 area, Parc At Murfreesboro presents a fantastic opportunity to embrace a luxury lifestyle. Our three-bedroom layouts cater perfectly to families, roommates, or those needing extra space, featuring modern finishes and abundant natural light.\n\nExperience the best of community living with resort-style amenities right at your doorstep. Enjoy a state-of-the-art fitness center, expansive dog park, and a cozy coffee bar where you can unwind and socialize. With easy access to major roads and local attractions, Parc At Murfreesboro offers everything you need in an ideal home setting near the heart of Murfreesboro, TN.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite island, stainless steel dishwasher, and open-concept living area.",
        "public_id": "019f6c10-3fff-72ad-85a9-b8a7e2a69669",
        "storage_key": "property/5757210235764736/019f6c10-3fff-72ad-85a9-b8a7e2a69669.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 37129",
      "seo_description": "Find spacious three bedroom apartments near 37129 at Parc At Murfreesboro, offering luxury amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2184"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "378205357"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a40\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a40\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4810270"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MH6L3LD"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "2437207418"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "d0211f14888bbdeb"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/gow3k7qyp2m"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/3b1cca7d-6f65-4253-93ac-dddd30f70314"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "629-356-5938"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik5ORDNtR2VsQVY5M0hOQmlzNFJaSEE9PSIsInZhbHVlIjoieHorUG5EUlhld2dPbnNQOUowWmRZQT09IiwibWFjIjoiNjc2YTFiN2Y0NTVkNDkwNjgwODcyYjk3YjJkY2M3ZDFlMzAxZGFlOTRjZjM0ZTk2MmVmNmEwNGE5MmY4ZDA3YSJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2184",
  "custom_repli_id": "378205357",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a40\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a40\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4810270",
  "custom_google_gtm_id": "GTM-MH6L3LD",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "2437207418",
  "custom_knock_community_id": "d0211f14888bbdeb",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/gow3k7qyp2m",
  "custom_self_guided_tour_url": "https://selftournow.com/property/3b1cca7d-6f65-4253-93ac-dddd30f70314",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "629-356-5938",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik5ORDNtR2VsQVY5M0hOQmlzNFJaSEE9PSIsInZhbHVlIjoieHorUG5EUlhld2dPbnNQOUowWmRZQT09IiwibWFjIjoiNjc2YTFiN2Y0NTVkNDkwNjgwODcyYjk3YjJkY2M3ZDFlMzAxZGFlOTRjZjM0ZTk2MmVmNmEwNGE5MmY4ZDA3YSJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-10-09T16:37:33.712Z';
